import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
  HostListener,
  ChangeDetectorRef,
  TemplateRef,
} from "@angular/core";
import { DataService } from "../../../../../shared/services/municipios.service";
import { BancosServices } from "../../../../../shared/services/bancos.service";
import { CargosService } from "../../../../../shared/services/cargos.service";
import { EmpresasService } from "../../../../../shared/services/empresas.service";
import { CivilService } from "../../../../../shared/services/civil.service";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";
import { InfraccionService } from "../../../../../shared/services/infracciones.service";
import { BeneficiarioService } from "../../../../../shared/services/beneficiarios.service";
import { AcademiaService } from "../../../../../shared/services/academia.service";
import { ExamenesMedicosService } from "../../../../../shared/services/examenesmedicos.service";
import { ExamenesRealizadosService } from "../../../../../shared/services/examenes_realizados.service";
import { LaboralService } from "../../../../../shared/services/laboral.service";
import { RazaService } from "../../../../../shared/services/raza..service";
import { NucleoFamiliarService } from "../../../../../shared/services/nucleofamiliar.service";
import { AreaService } from "../../../../../shared/services/area.service";
import { TipoContratoService } from "../../../../../shared/services/tipocontrato.service";
import { SeguridadSocialService } from "../../../../../shared/services/seguridadsocial.service";
import { Propietario } from "../../../../../shared/model/propietario";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { catchError,finalize } from 'rxjs/operators';


import {
  NgbAccordion,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { CondicionService } from "../../../../../shared/services/condicion.services";
import { CodigoInfraccionService } from "../../../../../shared/services/codigoinfraccion.service";
import { NivelEstudioService } from "../../../../../shared/services/nivelestudio.service";
import { TipoDocumentoService } from "../../../../../shared/services/tipodocumento.service";
import { ParentescoService } from "../../../../../shared/services/parentescos.service";
import { NgForm } from "@angular/forms";
import { Observable, of } from "rxjs";
import {
  NgbdSortableHeader,
  SortEvent,
} from "../../../../../shared/directives/NgbdSortableHeader";
import { Router } from "@angular/router";
import jsPDF from "jspdf";
import { Utils } from "../../../../../shared/utils/Utils";
import { ActivatedRoute } from "@angular/router";
import { TipoViviendaService } from "../../../../../shared/services/tipoVivienda.services";
import { forkJoin } from "rxjs";
import { EstadoMultaService } from "../../../../../shared/services/estadoMultas.service";
import { NgxPaginationModule } from "ngx-pagination";
import { FormsModule } from "@angular/forms";
import { FirmasComponent } from "../../../../firmas/firmas/firmas.component";
import { gpcGoogleService } from "../../../../../shared/services/gpcGoogle.service";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { TiposExamenService } from "../../../../../shared/services/tipos-examen.service";
import { HttpEventType } from "@angular/common/http";
import { DigitalesService } from "../../../../../shared/services/digitales.service";
import {
  CapacitacionAsistenciaView,
  CapacitacionesAsistentesService,
} from "../../../../../shared/services/capacitacion_asistentes.service";
import { CapacitacionProgramacionService } from "../../../../../shared/services/capacitaciones_programacion.service";
import { CapacitacionView } from "../../../../../shared/services/capacitacion.service";
import { CapacitacionInvitadosService } from "../../../../../shared/services/capacitaciones_invitados.service";
declare var require;
const Swal = require("sweetalert2");

interface AsistenciaRow extends CapacitacionAsistenciaView {
  estado?: number;
  capacitacion?: {
    nombre?: string;
    tema?: string;
  };
}

@Component({
  selector: "app-editar",
  templateUrl: "./editar.component.html",
  styleUrls: ["./editar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EditarComponent implements OnInit {
  propietarioSeleccionado: Propietario | null = null;
  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  administraciones: any[] = []; // Para almacenar administraciones
  fechaMaximaPermitida: string = "";
  dataRaza: any = null;
  areaData: any[] = [];
  tipocontratoData: any[] = [];
  seguridadsocialData: any[] = [];
  form: any = null;
  errores: any = { cargo: "", categoria: "" };
  municipios: any[] = []; // Arreglo donde almacenaremos los municipios
  bancos: any[] = [];
  datacargos: any[] = [];
  datacondicion: any[] = [];
  todasLasEmpresas: any[] = [];
  empresas: any[] = [];
  dataCiviles: any[] = [];
  selectedProgramacionId: number | null = null;
  formData: any = {
    cargo: "",
    categoria: "",
    numerolic: "",
    expediciolic: "",
    vencelic: "",
  };
  editAsistenciaModalRef?: NgbModalRef;
  datos: any[] = [];
  fechaVenceLic: Date | undefined = undefined;
  fechanacimiento: Date | undefined = undefined;
  FirmaContrato: Date | undefined = undefined;
  VenceContrato: Date | undefined = undefined;
  FechaEps: Date | undefined = undefined;
  FechaCobEps: Date | undefined = undefined;
  FechaArl: Date | undefined = undefined;
  FechaCobArl: Date | undefined = undefined;
  FechaAfp: Date | undefined = undefined;
  FechaCobAfp: Date | undefined = undefined;
  FechaCes: Date | undefined = undefined;
  FechaCobCes: Date | undefined = undefined;
  FechaCcf: Date | undefined = undefined;
  FechaCobEccf: Date | undefined = undefined;
  ExpedicioLic: Date | undefined = undefined;
  FechaPonal: Date | undefined = undefined;
  FechaProcu: Date | undefined = undefined;
  pageSize5: number = 5;
  page5: number = 1;
  totalItems5: number = 0;
  propietarios: any[] = [];
  estadosMultas: any[] = [];
  formEmpresa!: FormGroup;
  public selected = [];
  empresaselecionada: any;
  filteredTableItemsAsistencia: any[] = [];
  stateFilter: "all" | "active" | "inactive" = "all";
  pageSize = 5;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";
  loadingInvitados = false;
  public searchText = ""; // Texto para búsqueda
  total$!: Observable<number>; // Observable para obtener el total de elementos
  invitadosProgramacion: any[] = [];
  public show: boolean = false;
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  searchTerm: string = "";
  dropdownStates: boolean[] = [];
  public validate = false;
  public tooltipValidation = false;

  cedulasSeleccionadas = new Set<string>();
  tableItem$: any;
  filteredTableItem$: any;
  codigoinfracciondata: any[] = [];
  nivelestudiodata: any[] = [];
  tipodocumentodata: any[] = [];
  parentescodata: any[] = [];
  tiposExamenData: any[] = [];
  infraccionService: any;
  infracciones: any[] = [];
  beneficiarios: any[] = [];
  academias: any[] = [];
  laborales: any[] = [];
  infraccionForm: any;
  formInfraccion!: FormGroup;
  modal: any;
  editMode: boolean = false;
  editAsistenciaId: number | null = null;
  infraccionSeleccionada: any;
  formBeneficiario: any;
  beneficiarioSeleccionado: any = null;
  formAcademia!: FormGroup;
  academiaselecionada: any;
  laboralselecionada: any;
  formLaboral!: FormGroup;
  formExamenes: any;
  editError = "";
  examenesselecionadas: any;
  empresaARL: any;
  empresaAFP: any;
  empresaCES: any;
  empresaCCF: any;
  today: string = new Date().toISOString().split("T")[0];
  loading: boolean = false;
  examenes: any[] = [];
  tiposExamen: any[] = [];
  tableSize: number = 5;
  count: number = 0;
  empresaData: any[] = [];
  modalEmpresaRef!: NgbModalRef;
  examenesBase: any[] = [];
  tiposExamenProfesiograma: any[] = [];
  tipoExamenSeleccionado: any = null;
  examenesDataFiltrados: any[] = [];
  asistentes: any[] = [];
  capacitaciones: CapacitacionView[] = [];

  newAsistenciaForm: AsistenciaRow = {
    capacitacion_id: undefined,
    cedula: undefined,
    nombre: "",
    asistio: 1,
    aprobado: 0,
    calificacion: null,
    observaciones: "",
    estado: 1,
  };

  editAsistenciaForm: AsistenciaRow = {
    capacitacion_id: undefined,
    cedula: undefined,
    nombre: "",
    asistio: 1,
    aprobado: 0,
    calificacion: null,
    observaciones: "",
    estado: 1,
  };
  createModalRef: any;
  createError: string ="";
  programacionActivosData: any;

  public tooltipSubmit() {
    this.tooltipValidation = !this.tooltipValidation;
  }

  @ViewChild("inputTipo") inputTipo!: ElementRef;
  @ViewChild("inputCedula") inputCedula!: ElementRef;
  @ViewChild("inputPrimernombre") inputPrimernombre!: ElementRef;
  @ViewChild("inputFechanacimiento") inputFechanacimiento!: ElementRef;
  @ViewChild("inputPapellidos") inputPapellidos!: ElementRef;
  @ViewChild("inputGenero") inputGenero!: ElementRef;
  @ViewChild("inputEstadocivil") inputEstadocivil!: ElementRef;
  @ViewChild("inputEstratos") inputEstratos!: ElementRef;
  @ViewChild("inputRaza") inputRaza!: ElementRef;
  @ViewChild("inputTipodevivienda") inputTipodevivienda!: ElementRef;
  @ViewChild("inputCargos") inputCargos!: ElementRef;
  @ViewChild("inputCategoria") inputCategoria!: ElementRef;
  @ViewChild("inputNumerolic") inputNumerolic!: ElementRef;
  @ViewChild("inputExpedicioLic") inputExpedicioLic!: ElementRef;
  @ViewChild("inputFechaVenceLic") inputFechaVenceLic!: ElementRef;
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;
  @ViewChild("inputGmail") inputGmail!: ElementRef;
  @ViewChild("inputCondicion", { static: false }) inputCondicion!: ElementRef;
  @ViewChild("miFormulario") miFormulario!: NgForm;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChild(FirmasComponent, { static: false })
  firmasComponent!: FirmasComponent;
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  // Firma existente en edición
  firmaExistente: { ruta?: string } | null = null;

  async togglePanel(panelId: string) {
    // Si está en el panel de Datos Básicos y va a cambiar, guardar firma automáticamente
    if (this.activePanel.includes("static-1") && panelId !== "static-1") {
      console.log("🔄 Cambiando de panel - Guardando firma automáticamente...");
      if (this.firmasComponent && this.formData.cedula) {
        try {
          await this.firmasComponent.guardarFirma(true); // true = modo silencioso
          console.log("✅ Firma guardada automáticamente");
        } catch (error) {
          console.log("⚠️ No se pudo guardar firma (puede estar vacía)");
        }
      }
    }

    this.activePanel = this.activePanel.includes(panelId) ? [] : [panelId];
  }

  soloLetras(event: KeyboardEvent) {
    const charCode = event.key;
    const pattern = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;

    if (!pattern.test(charCode)) {
      event.preventDefault(); // Bloquea el ingreso de caracteres no permitidos
    }
  }

  public TipoDeDocumento = [
    { value: "NIT", label: "NIT" },
    { value: "CC", label: "CEDULA DE CIUDADANIA" },
    { value: "CE", label: "CEDULA DE EXTRANJERIA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "OTRO", label: "OTRO" },
  ];
  public Documento!: string; // Aquí se almacena el valor seleccionado del <ng-select>

  public Genero = [
    { value: "1", label: "MASCULINO" },
    { value: "2", label: "FEMENINO" },
  ];
  public Gene!: string;

  public TipoDeSangre = [
    { value: "1", label: "A+" },
    { value: "2", label: "A-" },
    { value: "3", label: "B+" },
    { value: "4", label: "B-" },
    { value: "5", label: "AB+" },
    { value: "6", label: "AB-" },
    { value: "7", label: "O+" },
    { value: "8", label: "O-" },
  ];
  public Sangre!: string;

  public Estrato = [
    { value: "0", label: "NO SELECCIONADO" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
  ];
  public Estra!: string;

  public TipoDeCuenta = [
    { value: "1", label: "AHORROS" },
    { value: "2", label: "CORRIENTE" },
    { value: "3", label: "OTRA" },
  ];
  public Cuenta!: string;

  TipoDeVivienda: any[] = [];
  public Vivienda!: string;

  public NucleoFamiliar = [
    { value: "1", label: "SOLO" },
    { value: "2", label: "CONYUGUE" },
    { value: "3", label: "CON CONYUGUE E HIJOS" },
    { value: "4", label: "CON CONYUGUE, HIJOS Y OTRO(S)" },
  ];
  public Nucleo!: string;

  public PadreFamiliar = [
    { value: "SI", label: "SI" },
    { value: "NO", label: "NO" },
  ];
  public Padre!: string;

  onPadreChange() {
    if (this.formData.padre === "1") {
    } else {
      this.formData.numeroHijos = 0;
    }
  }

  public Perfil = [
    { value: "1", label: "ADMIN" },
    { value: "2", label: "HUMANAS" },
  ];
  public perfil!: string;

  public JornadaLaboral = [
    { value: "1", label: "DIURNA" },
    { value: "2", label: "NOCTURNA" },
    { value: "3", label: "MIXTA" },
  ];
  public jornada!: string;

  public Categoria = [
    { value: "1", label: "MOTOS", disabled: true },
    { value: "2", label: "A1" },
    { value: "3", label: "A2" },

    { value: "4", label: "SERVICIO PARTICULAR", disabled: true },
    { value: "5", label: "B1" },
    { value: "6", label: "B2" },
    { value: "7", label: "B3" },

    { value: "8", label: "SERVICIO PUBLICO", disabled: true },
    { value: "9", label: "C1" },
    { value: "10", label: "C2" },
    { value: "11", label: "C3" },

    { value: "12", label: "TRANSPORTE FLUVIAL", disabled: true },
    { value: "13", label: "TRIPULANTE MOTORISTA" },
    { value: "14", label: "TRIPULANTE AYUDANTE FLUVIAL" },
    { value: "15", label: "NO TIENE" },
  ];
  public categoria!: string;

  public ResultadoPonal = [
    { value: "1", label: "SIN ANTECEDENTES" },
    { value: "2", label: "CON ANTECEDENTES" },
  ];
  public Resultado!: string;

  public detalleAntecedentesPonal: string = "";
  public detalleAntecedentesProcu: string = "";
  selectedFileEdit: File | null = null;
  previewEdit: string | ArrayBuffer | null = null;
  onChangeResultado(tipo: string) {
    if (tipo === "ponal" && this.formData.resultadoponal !== "2") {
      this.detalleAntecedentesPonal = ""; // Borra si cambia la opción en PONAL
    }
    if (tipo === "procuraduria" && this.formData.resultadoprocu !== "2") {
      this.detalleAntecedentesProcu = ""; // Borra si cambia la opción en PROCURADURIA
    }
  }

  onCargoChange() {
    if (this.formData.cargo !== "2") {
      this.formData.categoria = ""; // Borra la categoría si cambia de cargo
    }
  }

  public counter: number[] = [
    18, 40, 55, 40, 40, 40, 20, 40, 50.0, 40, 40, 50, 50, 40, 60, 40,
  ];
  public contents = ["Action", "Another Action", "Something Else Here"];

  dropzones = [
    { id: 1, name: "Cédula Ciudadanía Frontal", file: null },
    { id: 2, name: "Cédula Ciudadanía Posterior", file: null },
    { id: 3, name: "Licencia Frontal", file: null },
    { id: 4, name: "Licencia Posterior", file: null },
  ];

  onFileChange(event: any, dropzoneId: number) {
    const selectedFile = event.target.files[0];
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (dropzone && selectedFile) {
      selectedFile["preview"] = URL.createObjectURL(selectedFile);
      dropzone.file = selectedFile;
    }
    event.target.value = ""; // Permite volver a seleccionar el mismo archivo
  }

  removeFile(dropzoneId: number) {
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (dropzone) {
      dropzone.file = null;
    }
  }

  constructor(
    private dataService: DataService,
    private bancosService: BancosServices,
    private cargosService: CargosService,
    private empresasService: EmpresasService,
    private propietarioService: PropietarioService,
    private condicionSerivice: CondicionService,
    private civilService: CivilService,
    private capacitacionProgramacionService: CapacitacionProgramacionService,
    private razaService: RazaService,
    private nucleoFamiliarService: NucleoFamiliarService,
    private areaService: AreaService,
    private tipocontratoService: TipoContratoService,
    private seguridadsocialservice: SeguridadSocialService,
    
    private codigoinfraccionservice: CodigoInfraccionService,
    private nivelEstudioService: NivelEstudioService,
    private tipodocumentoservice: TipoDocumentoService,
    private parentescosservice: ParentescoService,
    private infraccionesService: InfraccionService,
    private beneficiariosservice: BeneficiarioService,
    private academiaservice: AcademiaService,
    private asistenciaService: CapacitacionesAsistentesService,
    private laboralservice: LaboralService,
    private examenesMedicosService: ExamenesMedicosService,
    private examenesRelizadosService: ExamenesRealizadosService,
    private empresaService: EmpresasService,
    private tiposExamenService: TiposExamenService,
    private digitalesService: DigitalesService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private tipoViviendaService: TipoViviendaService,
    private estadoMultaService: EstadoMultaService,
    private gpcGoogleService: gpcGoogleService,
    private administracionService: AdministracionService,
    private programacionService: CapacitacionProgramacionService,
    private capacitacionInvitadosService: CapacitacionInvitadosService,
    
  ) {
    this.formData = this.fb.group({
      tipo: ["", Validators.required],
      cedula: ["", Validators.required],
      primernombre: ["", Validators.required],
      papellidos: ["", Validators.required],
      fechaCreacion: [new Date()],
    });

    this.cedulasSeleccionadas = new Set<string>();
    ///this.cargarPropietarios();
    this.obtenerTiposVivienda();
  }

  ngOnInit(): void {
    // Cargar administraciones para obtener NIT
    this.administracionService.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data;
        // console.log('✅ Administraciones cargadas:', this.administraciones);
      },
      error: (err) => {
        console.error("❌ Error al cargar administraciones:", err);
      },
    });

    this.formInfraccion = this.fb.group({
      fecha: ["", Validators.required],
      tipo: ["", Validators.required],
      numero: ["", [Validators.required, Validators.pattern(/^\d+$/)]],
      codigo: ["", Validators.required],
      valortotal: ["", Validators.required],

      vrpagado: ["", Validators.required],
      vrsaldo: ["", Validators.required],
      estado: ["", Validators.required],
      fechacompromiso: [""],
      observaciones: [""],
    });

    this.formInfraccion.get("codigo")?.valueChanges.subscribe((codigo) => {
      const infraccion = this.codigoinfracciondata.find(
        (i) => i.codigo === codigo,
      );
      if (infraccion) {
        const valorCalculado = infraccion.diasSMLV * 58364;
        //console.log(valorCalculado);
        this.formInfraccion
          .get("valortotal")
          ?.setValue(valorCalculado, { emitEvent: false });
      }
    });
    // Calcular saldo automáticamente
    this.formInfraccion.valueChanges.subscribe((val) => {
      const valortotal = Number(val.valortotal) || 0;
      const vrpagado = Number(val.vrpagado) || 0;
      const saldo = valortotal - vrpagado;
      this.formInfraccion.get("vrsaldo")?.setValue(saldo, { emitEvent: false });
    });
    this.formBeneficiario = this.fb.group({
      tipodocumento: [""], // Opcional
      documento: ["", [Validators.required, Validators.pattern(/^\d+$/)]], // Obligatorio
      beneficiarios: [""], // Opcional
      edad: ["", [Validators.min(0)]], // Opcional, pero con validación si se ingresa un valor
      parentesco: [""], // Opcional
      estado: ["1", Validators.required],
    });
    this.formAcademia = this.fb.group({
      tipoestudio: ["", Validators.required],
      titulo: [""],
      tiempo: ["", Validators.pattern(/^\d+$/)],
      entidad: [""],
      terminacion: ["", [Validators.pattern(/^\d{4}$/)]], // Solo permite un año de 4 dígitos
    });
    this.formLaboral = this.fb.group({
      empresa: ["", Validators.required],
      cargo: ["", Validators.required],
      tiempo: ["", [Validators.required, Validators.min(1)]],
      telefono: ["", [Validators.required, Validators.pattern(/^\d{7,10}$/)]],
    });

    this.formEmpresa = this.fb.group({
      nit: ["", [Validators.pattern(/^[0-9]{10}$/)]],
      digito: [null],
      nombre: [null],
      direccion: [null],
      telefono: ["", [Validators.pattern(/^[0-9]{10}$/)]],
      celular: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: [null],
      observaciones: [null],
      ciudad: [null],
      eps: [false],
      arl: [false],
      afp: [false],
      ces: [false],
      ccf: [false],
      bancos: [false],
      transporte: [false],
      colegio: [false],
      cda: [false],
      taller: [false],
      eds: [false],
      contratista: [false],
      proveedor: [false],
      aseguradora: [false],
      almacen: [false],
      serviteca: [false],
      entidad: [false],
      estado: [1],
    });

    this.formExamenes = this.fb.group({
      fecha_realizo: ["", Validators.required],
      fecha_vencimiento: ["", Validators.required],
      entidad: [null],
    });

    this.cargarDatos();

    this.route.paramMap.subscribe((params) => {
      const id = params.get("id");
      if (id) {
        this.cargarDatosPropietario(id);
      } else {
        console.error("ID inválido recibido:", id);
      }
    });

    {
      const hoy = new Date();
      const fechaMinima = new Date(
        hoy.getFullYear() - 0,
        hoy.getMonth(),
        hoy.getDate(),
      );
      this.fechaMaximaPermitida = fechaMinima.toISOString().split("T")[0]; // Convierte a formato yyyy-mm-dd
    }
  }

  calcularIMC() {
    const peso = this.formData.peso;
    const alturaCM = this.formData.altura;

    if (!peso || !alturaCM || alturaCM <= 0) {
      this.formData.imc = "";
      this.formData.resultadoimc = "";
      return;
    }

    const alturaM = alturaCM / 100; // Convertir la altura a metros
    const imc = peso / (alturaM * alturaM);

    this.formData.imc = imc.toFixed(2); // Guardar el IMC con dos decimales

    // Determinar el resultado del IMC
    if (imc < 18.5) {
      this.formData.resultadoimc = "Bajo peso";
    } else if (imc >= 18.5 && imc < 24.9) {
      this.formData.resultadoimc = "Peso normal";
    } else if (imc >= 25 && imc < 29.9) {
      this.formData.resultadoimc = "Sobrepeso";
    } else {
      this.formData.resultadoimc = "Obesidad";
    }
  }

  calcularEdad(fechaNacimiento: string) {
    if (!fechaNacimiento || fechaNacimiento.length !== 10) {
      console.error("Fecha de nacimiento inválida:", fechaNacimiento);
      return;
    }

    const [year, month, day] = fechaNacimiento.split("-").map(Number);
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      console.error("Error al extraer año, mes y día:", { year, month, day });
      return;
    }

    const fechaNac = new Date(year, month - 1, day);
    const hoy = new Date();
    const fechaMinima = new Date(
      hoy.getFullYear() - 18,
      hoy.getMonth(),
      hoy.getDate(),
    );

    if (fechaNac > hoy) {
      console.error("No se pueden seleccionar fechas futuras.");
      alert("No se pueden seleccionar fechas futuras.");
      this.formData.fechanacimiento = "";
      return;
    }

    if (fechaNac > fechaMinima) {
      console.error("Debe ser mayor de 18 años.");
      alert("Debe ser mayor de 18 años.");
      this.formData.fechanacimiento = "";
      return;
    }

    let edad = hoy.getFullYear() - fechaNac.getFullYear();
    if (
      hoy.getMonth() < fechaNac.getMonth() ||
      (hoy.getMonth() === fechaNac.getMonth() &&
        hoy.getDate() < fechaNac.getDate())
    ) {
      edad--;
    }

    this.formData.edad = edad;
    console.log(`Edad calculada correctamente: ${edad}`);
  }

  validarTelefono(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ""); // Elimina todo lo que no sea número
    this.formData.telfijo = input.value.slice(0, 10); // Limita a 10 dígitos
  }

  validarTelefonoCelular(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ""); // Elimina todo lo que no sea número
    this.formData.telcel = input.value.slice(0, 10); // Limita a 10 dígitos
  }

  validarteleempresa(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ""); // Elimina todo lo que no sea número
    this.formData.telempresa = input.value.slice(0, 10); // Limita a 10 dígitos
  }

  updatePropietario() {
    // Asegurar que asumess sea null o un número, nunca string vacío
    let asumessValue = this.formData.asumess;
    if (asumessValue === "" || asumessValue === undefined) {
      asumessValue = null;
    } else if (typeof asumessValue === "string") {
      asumessValue = Number(asumessValue);
      if (isNaN(asumessValue)) asumessValue = null;
    }

    const propietario: Propietario = {
      tipo: this.formData.tipo || "",
      cedula: this.formData.cedula,
      lugarex:
        this.formData.lugarex &&
        this.formData.lugarex !== 0 &&
        this.formData.lugarex !== "0"
          ? this.formData.lugarex
          : null,
      primernombre: this.formData.primernombre || "",
      segundonombre: this.formData.segundonombre || "",
      papellidos: this.formData.papellidos || "",
      seapellidos: this.formData.seapellidos || "",
      fechanace: this.formData.fechanacimiento || null,
      edad:
        this.formData.edad !== undefined &&
        this.formData.edad !== null &&
        this.formData.edad !== ""
          ? Number(this.formData.edad)
          : 0,
      lugarnace:
        this.formData.lugarnace &&
        this.formData.lugarnace !== 0 &&
        this.formData.lugarnace !== "0"
          ? this.formData.lugarnace
          : null,
      genero: this.formData.genero || "",
      civil:
        this.formData.civil &&
        this.formData.civil !== 0 &&
        this.formData.civil !== "0"
          ? this.formData.civil
          : null,
      sangre: this.formData.sangre || "",
      direccion: this.formData.direccion || "",
      ciudad:
        this.formData.ciudad &&
        this.formData.ciudad !== 0 &&
        this.formData.ciudad !== "0"
          ? this.formData.ciudad
          : null,
      barrio: this.formData.barrio || "",
      estrato:
        this.formData.estrato &&
        this.formData.estrato !== 0 &&
        this.formData.estrato !== "0"
          ? this.formData.estrato
          : 0,
      telfijo: this.formData.telfijo || "",
      telcel: this.formData.telcel || "",
      telempresa: this.formData.telempresa || "",
      mail: this.formData.mail || "",
      banco:
        this.formData.banco &&
        this.formData.banco !== 0 &&
        this.formData.banco !== "0"
          ? this.formData.banco
          : null,
      tipocuenta: this.formData.tipocuenta || null,
      cuenta: this.formData.cuenta || null,
      raza: this.formData.raza || null,
      vivienda: this.formData.vivienda || null,
      nucleo: this.formData.nucleo || null,
      padre: this.formData.padre || "",
      nhijos:
        this.formData.nhijos !== undefined &&
        this.formData.nhijos !== null &&
        this.formData.nhijos !== ""
          ? Number(this.formData.nhijos)
          : 0,
      area: this.formData.area || null,
      password: this.formData.password || "",
      observaciones: this.formData.observaciones || "",
      condicion: this.formData.condicion || "",
      cargo: this.formData.cargo || null,
      tipocontrato: this.formData.tipocontrato || null,
      jornada: this.formData.jornada || "",
      firmacontrato:
        this.formData.FirmaContrato !== undefined &&
        this.formData.FirmaContrato !== null &&
        this.formData.FirmaContrato !== ""
          ? this.formData.FirmaContrato
          : (this.propietarioSeleccionado?.firmacontrato ?? null),
      vencecontrato:
        this.formData.VenceContrato !== undefined &&
        this.formData.VenceContrato !== null &&
        this.formData.VenceContrato !== ""
          ? this.formData.VenceContrato
          : (this.propietarioSeleccionado?.vencecontrato ?? null),
      lugartrabajo: this.formData.lugartrabajo || null,
      sueldo:
        this.formData.sueldo !== undefined &&
        this.formData.sueldo !== null &&
        this.formData.sueldo !== ""
          ? String(this.formData.sueldo)
          : "",
      asumess: asumessValue,
      camisa: this.formData.camisa || "",
      pantalon: this.formData.pantalon || "",
      zapatos: this.formData.zapatos || "",
      peso:
        this.formData.peso !== undefined &&
        this.formData.peso !== null &&
        this.formData.peso !== ""
          ? Number(this.formData.peso)
          : 0,
      altura:
        this.formData.altura !== undefined &&
        this.formData.altura !== null &&
        this.formData.altura !== ""
          ? Number(this.formData.altura)
          : 0,
      imc:
        this.formData.imc !== undefined &&
        this.formData.imc !== null &&
        this.formData.imc !== ""
          ? Number(this.formData.imc)
          : 0,
      resultadoimc: this.formData.resultadoimc || "",
      eps: this.formData.eps || (this.propietarioSeleccionado?.eps ?? ""),
      fechaeps:
        this.formData.FechaEps !== undefined &&
        this.formData.FechaEps !== null &&
        this.formData.FechaEps !== ""
          ? this.formData.FechaEps
          : (this.propietarioSeleccionado?.fechaeps ?? null),
      fechacobeps:
        this.formData.FechaCobEps !== undefined &&
        this.formData.FechaCobEps !== null &&
        this.formData.FechaCobEps !== ""
          ? this.formData.FechaCobEps
          : (this.propietarioSeleccionado?.fechacobeps ?? null),
      arl: this.formData.arl || (this.propietarioSeleccionado?.arl ?? ""),
      fechaarl:
        this.formData.FechaArl !== undefined &&
        this.formData.FechaArl !== null &&
        this.formData.FechaArl !== ""
          ? this.formData.FechaArl
          : (this.propietarioSeleccionado?.fechaarl ?? null),
      fechacobarl:
        this.formData.FechaCobArl !== undefined &&
        this.formData.FechaCobArl !== null &&
        this.formData.FechaCobArl !== ""
          ? this.formData.FechaCobArl
          : (this.propietarioSeleccionado?.fechacobarl ?? null),
      afp: this.formData.afp || (this.propietarioSeleccionado?.afp ?? ""),
      fechaafp:
        this.formData.FechaAfp !== undefined &&
        this.formData.FechaAfp !== null &&
        this.formData.FechaAfp !== ""
          ? this.formData.FechaAfp
          : (this.propietarioSeleccionado?.fechaafp ?? null),
      fechacobafp:
        this.formData.FechaCobAfp !== undefined &&
        this.formData.FechaCobAfp !== null &&
        this.formData.FechaCobAfp !== ""
          ? this.formData.FechaCobAfp
          : (this.propietarioSeleccionado?.fechacobafp ?? null),
      ces: this.formData.ces || (this.propietarioSeleccionado?.ces ?? ""),
      fechaces:
        this.formData.FechaCes !== undefined &&
        this.formData.FechaCes !== null &&
        this.formData.FechaCes !== ""
          ? this.formData.FechaCes
          : (this.propietarioSeleccionado?.fechaces ?? null),
      fechacobces:
        this.formData.FechaCobCes !== undefined &&
        this.formData.FechaCobCes !== null &&
        this.formData.FechaCobCes !== ""
          ? this.formData.FechaCobCes
          : (this.propietarioSeleccionado?.fechacobces ?? null),
      ccf: this.formData.ccf || (this.propietarioSeleccionado?.ccf ?? ""),
      fechaccf:
        this.formData.FechaCcf !== undefined &&
        this.formData.FechaCcf !== null &&
        this.formData.FechaCcf !== ""
          ? this.formData.FechaCcf
          : (this.propietarioSeleccionado?.fechaccf ?? null),
      fechacobeccf:
        this.formData.FechaCobEccf !== undefined &&
        this.formData.FechaCobEccf !== null &&
        this.formData.FechaCobEccf !== ""
          ? this.formData.FechaCobEccf
          : (this.propietarioSeleccionado?.fechacobeccf ?? null),
      categoria: this.formData.categoria || "",
      numerolic: this.formData.numerolic || "",
      expediciolic:
        this.formData.ExpedicioLic !== undefined &&
        this.formData.ExpedicioLic !== null &&
        this.formData.ExpedicioLic !== ""
          ? this.formData.ExpedicioLic
          : (this.propietarioSeleccionado?.expediciolic ?? null),
      vencelic:
        this.formData.fechaVenceLic !== undefined &&
        this.formData.fechaVenceLic !== null &&
        this.formData.fechaVenceLic !== ""
          ? this.formData.fechaVenceLic
          : (this.propietarioSeleccionado?.vencelic ?? null),
      fechaponal:
        this.formData.FechaPonal !== undefined &&
        this.formData.FechaPonal !== null &&
        this.formData.FechaPonal !== ""
          ? this.formData.FechaPonal
          : (this.propietarioSeleccionado?.fechaponal ?? null),
      resultadoponal: this.formData.resultadoponal || "",
      anteponal: this.formData.anteponal || "",
      anteprocu: this.formData.anteprocu || "",
      fechaprocu:
        this.formData.FechaProcu !== undefined &&
        this.formData.FechaProcu !== null &&
        this.formData.FechaProcu !== ""
          ? this.formData.FechaProcu
          : (this.propietarioSeleccionado?.fechaprocu ?? null),
      resultadoprocu: this.formData.resultadoprocu || "",
      existe: false,
      fechaNacimiento: "",
    };

   // console.log(propietario);

    this.propietarioService
      .updatePropietario(this.formData.cedula, propietario)
      .subscribe(
        async (response) => {
          //console.log("Datos guardados:", response);
          if (this.firmasComponent && this.firmasComponent.tieneFirma()) {
            try {
              await this.firmasComponent.guardarFirma(true);
            } catch (error) {
              console.error("Error al guardar firma automáticamente:", error);
            }
          }
          //alert("Datos guardados con éxito");
          this.router.navigate(["listados/activos"]);
        },
        (error) => {
          console.log("Error al guardar los datos:", error);
          //alert(`Error al guardar los datos: ${error.message || error}`);
        },
      );
  }

  fechaMaximaExpedicion: string = new Date().toISOString().split("T")[0];
  fechaMinimaPermitida: string = new Date().toISOString().split("T")[0];

  onDateChange(fechaObj: any, campo: string) {
    if (!fechaObj) {
      console.error("fechaObj está vacío:", fechaObj);
      return;
    }

    const fechaConvertida = this.convertirFecha(fechaObj);
    if (!fechaConvertida) {
      console.error("Error al convertir la fecha:", fechaObj);
      return;
    }

    const hoy = new Date();
    const fechaHoy = hoy.toISOString().split("T")[0];
    const fechaSeleccionada = new Date(fechaConvertida);

    if (campo === "vencecontrato" && fechaSeleccionada <= hoy) {
      console.error("Error: Ingrese una fecha futura.");
      alert("Ingrese una fecha futura.");
      this.formData[campo] = "";
      return;
    }

    if (campo === "expediciolic" && fechaSeleccionada >= hoy) {
      console.error("Error: Ingrese una fecha pasada.");
      alert("Ingrese una fecha pasada.");
      this.formData[campo] = "";
      return;
    }

    this.formData[campo] = fechaConvertida;

    if (campo === "fechanace") {
      this.calcularEdad(fechaConvertida);
    }
  }

  actualizarFechas(fechaConvertida: string, campo: string) {
    const camposFecha = [
      "fechaVenceLic",
      "fechanace",
      "FirmaContrato",
      "VenceContrato",
      "FechaEps",
      "FechaCobEps",
      "FechaArl",
      "FechaCobArl",
      "FechaAfp",
      "FechaCobAfp",
      "FechaCes",
      "FechaCobCes",
      "FechaCcf",
      "FechaCobEccf",
      "ExpedicioLic",
      "FechaPonal",
      "FechaProcu",
    ];

    if (camposFecha.includes(campo)) {
      this.formData[campo] = fechaConvertida;
    }
  }

  withConfirmation() {
    this.validate = true;

    if (!this.formData.tipo) {
      this.errores.tipo = "Por favor, seleccione una opción.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputTipo) {
          this.inputTipo.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione un tipo de documento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputTipo no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.cedula) {
      this.errores.cedula = "Por favor, ingresa un número de documento.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputCedula) {
          this.inputCedula.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresar un número de documento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputCedula no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.primernombre) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.primernombre = "Por favor, ingresa el nombre.";
      setTimeout(() => {
        if (this.inputPrimernombre) {
          this.inputPrimernombre.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresar el primer nombre",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputPrimernombre no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.papellidos) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.papellidos = "Por favor, ingresa el primer apellido.";
      setTimeout(() => {
        if (this.inputPapellidos) {
          this.inputPapellidos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresa el primer apellido",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputPapellidos no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.fechanace) {
      this.errores.fechanace = "Por favor, seleccione una fecha de nacimiento.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputFechanacimiento) {
          this.inputFechanacimiento.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione una fecha de nacimiento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputFechanacimiento no está disponible.");
        }
      });
      return;
    }

    /* if (!this.formData.genero) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.genero = "Por favor, seleccione el genero.";
      setTimeout(() => {
        if (this.inputGenero) {
          this.inputGenero.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el genero",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputGenero no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.civil) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.civil = "Por favor, seleccione el estado civil.";
      setTimeout(() => {
        if (this.inputEstadocivil) {
          this.inputEstadocivil.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el estado civil",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputEstadocivil no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.estrato) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.estrato = "Por favor, seleccione el estrato social.";
      setTimeout(() => {
        if (this.inputEstratos) {
          this.inputEstratos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Selecciona el estrato social",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputEstratos no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.raza) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.raza = "Por favor, seleccione la raza o grupo étnico:.";
      setTimeout(() => {
        if (this.inputRaza) {
          this.inputRaza.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione la raza o grupo étnico:",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
        }
      });
      return;
    }

    if (!this.formData.vivienda) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.vivienda = "Por favor, seleccione el tipo de vivienda.";
      setTimeout(() => {
        if (this.inputTipodevivienda) {
          this.inputTipodevivienda.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el tipo de vivienda",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
        }
      });
      return;
    } */
    if (!this.formData.condicion) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.condicion = "Por favor, selecciona la condicion laboral.";
      setTimeout(() => {
        if (this.inputCondicion) {
          this.inputCondicion.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Selecciona la condicion laboral",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
        }
      });
      return;
    }

    if (!this.formData.cargo) {
      if (this.accordion && !this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.cargo = "Por favor, seleccione el cargo.";

      setTimeout(() => {
        if (this.inputCargos?.nativeElement) {
          this.inputCargos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el cargo",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.error("Error: inputCargos no está disponible.");
        }
      }, 0);

      return;
    }

    if (this.formData.cargo === "2") {
      if (!this.formData.categoria) {
        if (!this.accordion.isExpanded("static-2")) {
          this.accordion.toggle("static-2");
        }
        this.errores.categoria =
          "Por favor, seleccione la categoria de licencia.";
        setTimeout(() => {
          if (this.inputCategoria) {
            this.inputCategoria.nativeElement.focus();
            Swal.fire({
              title: "Campo requerido",
              text: "Seleccione la categoria de licencia",
              icon: "info",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });
          } else {
          }
        });
        return;
      }

      if (!this.formData.numerolic) {
        if (!this.accordion.isExpanded("static-2")) {
          this.accordion.toggle("static-2");
        }
        this.errores.numerolic = "Por favor, Ingresa el número de licencia.";
        setTimeout(() => {
          if (this.inputNumerolic) {
            this.inputNumerolic.nativeElement.focus();
            Swal.fire({
              title: "Campo requerido",
              text: "Ingresa el número de licencia",
              icon: "info",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });
          } else {
          }
        });
        return;
      }

      if (!this.formData.expediciolic) {
        if (!this.accordion.isExpanded("static-2")) {
          this.accordion.toggle("static-2");
        }
        this.errores.expediciolic =
          "Por favor, Seleccione la fecha de expedición.";
        setTimeout(() => {
          if (this.inputExpedicioLic) {
            this.inputExpedicioLic.nativeElement.focus();
            Swal.fire({
              title: "Campo requerido",
              text: "Seleccione la fecha de expedición",
              icon: "info",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });
          } else {
          }
        });
        return;
      }

      if (!this.formData.vencelic) {
        if (!this.accordion.isExpanded("static-2")) {
          this.accordion.toggle("static-2");
        }
        this.errores.vencelic =
          "Por favor, Seleccione la fecha de vencimiento.";
        setTimeout(() => {
          if (this.inputFechaVenceLic) {
            this.inputFechaVenceLic.nativeElement.focus();
            Swal.fire({
              title: "Campo requerido",
              text: "Seleccione la fecha de vencimiento",
              icon: "info",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            });
          } else {
          }
        });
        return;
      }
    }

    Swal.fire({
      title: "Actualizar",
      text: "¿Desea actualizar persona?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.updatePropietario();

        //this.resetForm();
      }
    });
  }
  resetForm() {
    this.formData = {
      tipo: "",
      cedula: "",
      primernombre: "",
      papellidos: "",
      fechanace: "",
      genero: "",
      civil: "",
      estrato: "",
      raza: "",
      vivienda: "",
      condicion: "",
      cargo: "",
      categoria: "",
    };
    this.errores = {};
  }

  validarEnvio = false;

  validarCargo() {
    this.errores = {};
    this.validarEnvio = true;
    let esValido = true;
    let primerError = null;
    //console.log("validar cargo");
    //console.log(this.formData.cargo);

    if (this.formData.cargo === "2") {
      if (!this.formData.categoria || this.formData.categoria.trim() === "") {
        this.errores.categoria = "Por favor, seleccione una categoría.";
        esValido = false;
        if (!primerError) primerError = "categoria";
      }

      if (
        !this.formData.numerolic ||
        String(this.formData.numerolic).trim() === ""
      ) {
        this.errores.numerolic = "El Número de Licencia es obligatorio.";
        esValido = false;
        if (!primerError) primerError = "numerolic";
      }

      if (
        !this.formData.expediciolic ||
        String(this.formData.expediciolic).trim() === ""
      ) {
        this.errores.expediciolic = "La Fecha de Expedición es obligatoria.";
        esValido = false;
        if (!primerError) primerError = "expediciolic";
      }

      if (
        !this.formData.vencelic ||
        String(this.formData.vencelic).trim() === ""
      ) {
        this.errores.vencelic = "La Fecha de Vencimiento es obligatoria.";
        esValido = false;
        if (!primerError) primerError = "vencelic";
      }
    }

    if (!esValido) {
      setTimeout(() => {
        if (primerError === "categoria" && this.inputCategoria) {
          this.inputCategoria.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Por favor, seleccione una categoría.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "numerolic" && this.inputNumerolic) {
          this.inputNumerolic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese un número de licencia.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "expediciolic" && this.inputExpedicioLic) {
          this.inputExpedicioLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese una fecha de expedición.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "vencelic" && this.inputFechaVenceLic) {
          this.inputFechaVenceLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese una fecha de vencimiento.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        }
      });

      return false;
    }
  }

  convertirFecha(fechaObj: any): string {
    if (typeof fechaObj === "string" && fechaObj.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return fechaObj;
    }

    if (!fechaObj || !fechaObj.year || !fechaObj.month || !fechaObj.day) {
      console.error("Datos inválidos en fechaObj:", fechaObj);
      return "";
    }

    let year = fechaObj.year;
    let month = fechaObj.month;
    let day = fechaObj.day;

    const fechaHoy = new Date();
    const maxYear = fechaHoy.getFullYear();
    const maxMonth = 12;
    const maxDay = new Date(year, month, 0).getDate(); // Último día del mes

    if (year > maxYear) {
      console.error("El año ingresado es inválido.");
      alert(`Ingrese un año menor o igual a ${maxYear}.`);
      return "";
    }

    if (month > maxMonth || month < 1) {
      console.error("El mes ingresado es inválido.");
      alert("Ingrese un mes entre 01 y 12.");
      return "";
    }

    if (day > maxDay || day < 1) {
      console.error("El día ingresado es inválido.");
      alert(`Ingrese un día entre 01 y ${maxDay}.`);
      return "";
    }

    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  validarCorreo() {
    const email = this.formData.mail;

    if (!email) {
      this.errores.mail = "";
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      this.errores.mail = "Correo electrónico inválido.";
    } else if (email.includes("gmail")) {
      this.errores.mail = 'Correo electrónico no válido con "gmail".';
    } else {
      this.errores.mail = "";
    }
  }

  guardar() {
    this.validarCorreo();

    if (this.errores.mail) {
      return;
    }
  }

  @HostListener("document:click", ["$event"])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = "";
      }
    });

    // Establecemos la columna y dirección de orden
    // this.service.sortColumn = column;
    // this.service.sortDirection = direction;
  }

  sortData(column: string) {
    if (!this.propietarios || this.propietarios.length === 0) return;

    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    this.propietarios.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Manejo de valores nulos o indefinidos
      if (valueA == null) valueA = "";
      if (valueB == null) valueB = "";

      // Si la columna es de tipo fecha, convertir a objetos Date
      if (column.includes("fecha")) {
        valueA = new Date(valueA).getTime();
        valueB = new Date(valueB).getTime();
      }

      // Comparación de valores
      if (valueA < valueB) {
        return this.sortDirection === "asc" ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === "asc" ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.propietarios; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.propietarios.filter((propietario) => {
      // Ajusta los campos por los que quieres buscar
      return (
        propietario.fecha.toLowerCase().includes(term) ||
        propietario.tipo.toLowerCase().includes(term) ||
        propietario.papellidos.toLowerCase().includes(term) ||
        propietario.seapellidos.toLowerCase().includes(term) ||
        propietario.cedula.toLowerCase().includes(term) ||
        propietario.mail.toLowerCase().includes(term) ||
        propietario.numerolic.toLowerCase().includes(term) ||
        propietario.direccion.toLowerCase().includes(term) ||
        propietario.cargoData.cargos.toLowerCase().includes(term) ||
        propietario.condicionLaboral.label.toLowerCase().includes(term) ||
        propietario.telfijo.toLowerCase().includes(term) ||
        propietario.telcel.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) =>
      i === index ? !state : false,
    );
  }

  listarPropietarios(): void {
    this.propietarioService.getPropietarios().subscribe({
      next: (data) => {
        if (data?.propietarios) {
          this.propietarios = data.propietarios.map((propietario) => ({
            ...propietario,
            showMenu: false,
          }));
          console.log(this.propietarios);
        }
      },
      error: (err) => console.error("Error cargando propietarios", err),
    });
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  inactivarPersona(idPersona: string) {
    // console.log(idPersona);
    this.avisoInactivarPersona(idPersona);
  }

  avisoInactivarPersona(idPersona: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: "¿Desea inactivar a la persona con NIP: " + idPersona + "?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        //consume el metodo para actualiza el estado de la persona
        this.propietarioService
          .updatePropietariosEstado(idPersona, 2)
          .subscribe({
            next: (response) => {
              Swal.fire({
                icon: "success",
                title: "¡Éxito!",
                text: response.message,
                confirmButtonText: "Aceptar",
              });

              // 🔹 Refrescar la lista de propietarios
              this.listarPropietarios();
            },
            error: (error) => console.error("Error:", error),
          });
      }
    });
  }

  editarPersona(idPersona: string) {
    //console.log(idPersona);
    this.router.navigate(["/persona/editar"]);
  }

  ExportaHV(idPersona: string) {
    //console.log(idPersona);
    const doc = new jsPDF({
      orientation: "portrait", // Vertical
      unit: "mm",
      compress: true,
      format: "letter", // Tamaño carta (216 × 279 mm)
    });

    // Ruta de la imagen en assets
    const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";
    const imgFoto = "../../../../../assets/images/hoja_vida/foto.png";

    // Convertir imagen en base64
    this.getBase64Image(imgFoto).then((fotoBase64) => {
      this.getBase64Image(imgUrl).then((imgData) => {
        doc.addImage(imgData, "JPG", 0, 0, 184, 270); // Agregar imagen al PDF
        doc.addImage(fotoBase64, "JPG", 20, 20, 40, 40); // (x, y, ancho, alto)

        // ✍️ Agregar el nombre debajo de la foto
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.setTextColor(255, 255, 255);
        doc.text("JOSÉ JORGE", 40, 70, { align: "center" });
        doc.text("ARRIETA NARVAEZ", 40, 76, { align: "center" });

        doc.roundedRect(2, 90, 75, 13, 1, 1, "F"); // Rectángulo redondeado
        // ✍️ Configurar el texto sobre el rectángulo
        doc.setFont("helvetica", "bold"); // Fuente en negrita
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Color blanco
        doc.setFontSize(12);
        // 📌 Centrar el texto en el rectángulo
        const text = "ASESOR FINANCIERO";
        const textWidth = doc.getTextWidth(text); // Obtener ancho del texto
        const centerX = 2 + 75 / 2 - textWidth / 2; // Centrado en X
        const centerY = 88 + 13 / 2 + 3; // Centrado en Y (ajustado)
        doc.text(text, centerX, centerY);

        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255); // Color blanco
        doc.setFont("helvetica", "bold");
        doc.text("CC 1065579386", 5, 110);
        doc.text("EXPEDIDA EN: VALLEDUPAR", 5, 110 + 6);
        doc.text("FECHA NACIMIENTO: 28/03/1986", 5, 110 + 12);
        doc.text("BARRANQUILLA - ATLANTICO", 5, 110 + 18);
        doc.text("ESTADO CIVIL: CASADO", 5, 110 + 24);

        doc.setTextColor(0, 0, 0); // Color blanco
        doc.roundedRect(2, 140, 75, 13, 1, 1, "F"); // Rectángulo redondeado
        // ✍️ Configurar el texto sobre el rectángulo
        doc.setFontSize(12);
        const text2 = "CONTACTO";
        const textWidth2 = doc.getTextWidth(text2); // Obtener ancho del texto
        const centerX2 = 2 + 75 / 2 - textWidth2 / 2; // Centrado en X
        const centerY2 = 139 + 13 / 2 + 3; // Centrado en Y (ajustado)
        doc.text(text2, centerX2, centerY2);
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text("CR 65C # 72-150 T1 1107", 5, 160);
        doc.text("BELLO -  SAN GABRIEL", 5, 160 + 6);
        doc.text("+57 3135372913 - 604 5160047", 5, 160 + 12);
        doc.text("jjarrieta@indesoftsas.com", 5, 160 + 18);

        doc.setTextColor(0, 0, 0); // Color blanco
        doc.roundedRect(2, 190, 75, 13, 1, 1, "F"); // Rectángulo redondeado
        // ✍️ Configurar el texto sobre el rectángulo
        doc.setFontSize(12);
        const text3 = "LICENCIA DE CONDUCCIÓN";
        const textWidth3 = doc.getTextWidth(text3); // Obtener ancho del texto
        const centerX3 = 2 + 75 / 2 - textWidth3 / 2; // Centrado en X
        const centerY3 = 188 + 13 / 2 + 3; // Centrado en Y (ajustado)
        doc.text(text3, centerX3, centerY3);
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text("1065579386 - C2", 5, 210);
        doc.text("31/12/2030", 5, 216);
        doc.text("RH: 0+", 5, 222);

        // 🔹 Encabezado "Experiencia Laboral"
        doc.setFillColor(115, 102, 255); // Color de fondo púrpura
        doc.roundedRect(85, 15, 115, 15, 3, 3, "F"); // Rectángulo redondeado
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.text("EXPERIENCIA LABORAL", 140, 25, { align: "center" });

        // 📝 Información de Experiencia Laboral
        this.addExperience(
          doc,
          "EMPRESA XYZ",
          "ASESOR FINANCIERO",
          "36 MESES",
          "3135372913",
          42,
        );
        this.addExperience(
          doc,
          "EMPRESA ABC",
          "ANALISTA DE DATOS",
          "24 MESES",
          "3101234567",
          68,
        );

        // 🔹 Encabezado "Formación"
        doc.setFillColor(115, 102, 255);
        doc.roundedRect(85, 92, 115, 15, 3, 3, "F");
        doc.setFontSize(16);
        doc.setTextColor(255, 255, 255);
        doc.setFont("helvetica", "bold");
        doc.text("FORMACIÓN ACADEMICA", 142, 101, { align: "center" });

        // 📌 Información Académica
        this.addEducation(
          doc,
          "UNIVERSIDAD XYZ",
          "TECNOLOGO",
          "PROGRAMADOR DE SOFTWARE",
          "2025",
          118,
        );
        this.addEducation(
          doc,
          "SENA ANTIOQUIA",
          "TECNICO",
          "PROGRAMADOR WEB",
          "2023",
          145,
        );

        doc.setFillColor(115, 102, 255); // Color de fondo púrpura
        doc.roundedRect(85, 175, 115, 15, 3, 3, "F"); // Rectángulo redondeado
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.text("CURSOS", 140, 185, { align: "center" });

        this.addCursos(
          doc,
          "SENA ANTIOQUIA",
          "CURSO TEORICO",
          "MANEJO DEFENSIVOS",
          "2025",
          200,
        );
        this.addCursos(
          doc,
          "SENA ANTIOQUIA",
          "CURSO TEORICO",
          "MANEJO DEFENSIVOS",
          "2025",
          230,
        );

        // doc.line(90, 245, 150,245); // Línea de separación
        // 🔥 Footer
        this.addFooter(doc);

        // 📄 Generar el PDF y abrir en nueva pestaña
        const pdfBlob = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");
      });
    });
  } // 🔹 Función para agregar experiencia laboral
  addExperience(
    doc: jsPDF,
    empresa: string,
    cargo: string,
    tiempo: string,
    telefono: string,
    y: number,
  ) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`EMPRESA: ${empresa}`, 90, y);
    doc.setFont("helvetica", "normal");
    doc.text(`CARGO: ${cargo}`, 90, y + 6);
    doc.text(`TIEMPO: ${tiempo}`, 90, y + 12);
    doc.text(`TELÉFONO: ${telefono}`, 90, y + 18);
  }

  // 🔹 Función para agregar educación
  addEducation(
    doc: jsPDF,
    institucion: string,
    nivel: string,
    carrera: string,
    año: string,
    y: number,
  ) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(institucion, 90, y);
    doc.setFont("helvetica", "normal");
    doc.text(nivel, 90, y + 6);
    doc.text(carrera, 90, y + 12);
    doc.text(año, 90, y + 18);
  }

  // 🔹 Función para agregar addCursos
  addCursos(
    doc: jsPDF,
    institucion: string,
    nivel: string,
    carrera: string,
    año: string,
    y: number,
  ) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(institucion, 90, y);
    doc.setFont("helvetica", "normal");
    doc.text(nivel, 90, y + 6);
    doc.text(carrera, 90, y + 12);
    doc.text(año, 90, y + 18);
  }

  // 🔹 Función para agregar footer correctamente
  addFooter(doc: jsPDF) {
    const pageHeight = doc.internal.pageSize.height; // ✅ Obtener altura de la página correctamente
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(
      "Hoja de Vida - Generada by Admin SEAF - www.indesoftsas.com",
      105,
      pageHeight - 8,
      { align: "center" },
    );
  }

  // Convertir imagen a Base64
  getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgUrl;
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a Base64
      };

      img.onerror = (error) => reject(error);
    });
  }
  ngOnDestroy() {
    //  this.algunObservable.unsubscribe();
  }

  openCreateForm() {
    Swal.fire({
      title: "Crear Nuevo Registro",
      html: `
      <input id="nombre" class="swal2-input" placeholder="Nombre">
      <input id="email" class="swal2-input" type="email" placeholder="Correo">
    `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const nombre = (document.getElementById("nombre") as HTMLInputElement)
          .value;
        const email = (document.getElementById("email") as HTMLInputElement)
          .value;
        if (!nombre || !email) {
          Swal.showValidationMessage("Todos los campos son obligatorios");
          return false;
        }
        return { nombre, email };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Guardado",
          "El registro ha sido creado exitosamente",
          "success",
        );
      }
    });
  }

  openModal1(content: any, infraccion?: any) {
    if (infraccion) {
      this.editMode = true;
      this.infraccionSeleccionada = infraccion;
      this.formInfraccion.patchValue(infraccion); // Carga los datos en el formulario
    } else {
      this.editMode = false;
      this.formInfraccion.reset(); // Limpia el formulario para nueva infracción
    }

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

  guardarInfraccion() {
    if (this.formInfraccion.invalid) {
      Swal.fire({
        icon: "error",
        title: "Completar campos",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    const datosInfraccion = {
      ...this.formInfraccion.value,
      documento: this.formData.cedula,
    };

    const mostrarError = (err: any, accion: string) => {
      const mensaje = err.error || `Error al ${accion}.`;
      const detalle = Array.isArray(err.detalles)
        ? err.detalles.join(", ")
        : "";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: detalle ? `${mensaje}: ${detalle}` : mensaje,
      });
    };

    if (this.editMode) {
      this.infraccionesService
        .updateInfraccion(this.infraccionSeleccionada.numero, datosInfraccion)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Infracción actualizada.",
            });
            this.modalService.dismissAll();
            this.listarInfracciones();
          },
          error: (err) => mostrarError(err, "actualizar"),
        });
    } else {
      this.infraccionesService.createInfraccion(datosInfraccion).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado",
            text: "Infracción creada correctamente.",
          });
          this.formInfraccion.reset();
          this.modalService.dismissAll();
          this.listarInfracciones();
        },
        error: (err) => mostrarError(err, "guardar"),
      });
    }
  }

  openModal2(content: any) {
    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-width",
    });
  }

  cargarPropietarios() {
    this.propietarios = [
      {
        cedula: "123456",
        primernombre: "Juan",
        apellido: "Pérez",
        examenes: [
          {
            nombre: "Exámen Médico",
            realizado: "Sí",
            resultado: "Apto",
            recomendaciones: "Ninguna",
          },
          {
            nombre: "Audiometría",
            realizado: "No",
            resultado: "-",
            recomendaciones: "Realizar examen",
          },
        ],
      },
      {
        cedula: "789012",
        primernombre: "Ana",
        apellido: "Gómez",
        examenes: [
          {
            nombre: "Visiometría",
            realizado: "Sí",
            resultado: "Normal",
            recomendaciones: "Control anual",
          },
        ],
      },
    ];
  }

  toggleTabla(cedula: string) {
    if (this.cedulasSeleccionadas.has(cedula)) {
      this.cedulasSeleccionadas.delete(cedula);
    } else {
      this.cedulasSeleccionadas.add(cedula);
    }
    this.cedulasSeleccionadas = new Set(this.cedulasSeleccionadas); // Forzar actualización
  }

  onSearchChange(searchText: string) {
    this.searchText = searchText.toLowerCase(); // Convierte el texto de búsqueda a minúsculas
    this.filterData(); // Llama a la función que filtra los datos
  }

  // Filtrar los datos
  filterData() {
    this.tableItem$.subscribe((data: Propietario[]) => {
      const filteredData = data.filter(
        (item) => item.primernombre.toLowerCase().includes(this.searchText), // Filtra por el campo 'nombre'
      );
      this.filteredTableItem$.next(filteredData); // Actualiza los resultados filtrados
    });
  }

  personas: any[] = [
    { tipo: "", documento: "", nombre: "", edad: "", parentesco: "" },
  ];
  personas2: any[] = [
    {
      NiveldeEstudio: "",
      TituloObtenido: "",
      AñosHoras: "",
      Institucion: "",
      Terminacion: "",
    },
  ];
  personas3: any[] = [{ Empresa: "", Cargo: "", Laborado: "", Telefono: "" }];

  agregarPersona() {
    this.personas.push({
      tipo: "",
      documento: "",
      nombre: "",
      edad: "",
      parentesco: "",
    });
  }

  eliminarPersona(index: number) {
    if (this.personas.length > 1) {
      this.personas.splice(index, 1);
    }
  }

  agregarPersona2() {
    this.personas2.push({
      NiveldeEstudio: "",
      TituloObtenido: "",
      AñosHoras: "",
      Institucion: "",
      Terminacion: "",
    });
  }

  eliminarPersona2(index: number) {
    if (this.personas2.length > 1) {
      this.personas2.splice(index, 1);
    }
  }

  agregarPersona3() {
    this.personas3.push({ Empresa: "", Cargo: "", Laborado: "", Telefono: "" });
  }

  eliminarPersona3(index: number) {
    if (this.personas3.length > 1) {
      this.personas3.splice(index, 1);
    }
  }
  listarInfracciones(): void {
    this.infraccionesService
      .getInfraccionesByDocumento(this.formData.cedula)
      .subscribe({
        next: (data) => {
          this.infracciones =
            Array.isArray(data) && data.length > 0
              ? data.map((infraccion) => ({ ...infraccion, showMenu: false }))
              : [];
        },
        error: (err) => {
          console.error("❌ Error cargando infracciones:", err);
          this.infracciones = [];
        },
      });
  }

  inactivarInfraccion(numero: string | number) {
    const numeroStr = String(numero); // Convertimos a string

    Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a inactivar la infracción con número: ${numeroStr}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.infraccionesService.deleteInfraccion(numeroStr).subscribe({
          next: () => {
            Swal.fire(
              "¡Eliminado!",
              "La infracción ha sido eliminada.",
              "success",
            );
            this.listarInfracciones(); // Recargar lista
          },
          error: (error) => {
            console.error("❌ Error al eliminar infracción:", error);
            Swal.fire("Error", "No se pudo eliminar la infracción.", "error");
          },
        });
      }
    });
  }

  listarBeneficiarios(): void {
    this.beneficiariosservice.getBeneficiarios().subscribe({
      next: (data) => {
        this.beneficiarios = data.map((beneficiarios) => ({
          ...beneficiarios,
          showMenu: false,
        }));
      },
      error: (err) => console.error("Error cargando infracciones", err),
    });
  }

  listarLaboral(): void {
    this.laboralservice.getLaboralByCedula(this.formData.cedula).subscribe({
      next: (data) => {
        if (Array.isArray(data) && data.length > 0) {
          this.laborales = data.map((laboral) => ({
            ...laboral,
            showMenu: false,
          }));
        } else {
          this.laborales = []; // Si no hay datos, asignamos un array vacío
        }
      },
      error: (err) => {
        console.error("Error cargando experiencia laboral", err);
        this.laborales = []; // En caso de error, evitar que quede undefined
      },
    });
  }

  listarExamenes(): void {
    this.examenesMedicosService
      .getExamenesMedicosByCedula(this.formData.cedula)
      .subscribe({
        next: (data: any[]) => {
          console.log("DATA => ", data);

          this.examenes = data.map((examen: any) => ({
            ...examen,
            showMenu: false,
          }));

          console.log("EXAMENES => ", this.examenes);
        },
        error: (err) => {
          console.error("Error cargando exámenes", err);
        },
      });
  }

  cerrarModal(modal: any) {
    if (modal) {
      modal.dismiss();
    } else {
      console.error("⚠️ Error: El modal no está definido.");
    }
  }

  cargarBeneficiarios() {
    this.beneficiariosservice.getBeneficiarios().subscribe({
      next: (data) => {
        this.beneficiarios = data;
      },
      error: (err) => {
        console.error("❌ Error al cargar beneficiarios:", err);
      },
    });
  }

  inactivarBeneficiario(documento: string | number) {
    const documentoNum = Number(documento); // Asegura que sea número

    Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a inactivar al beneficiario con documento: ${documentoNum}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.beneficiariosservice.deleteBeneficiario(documentoNum).subscribe({
          next: () => {
            Swal.fire(
              "¡Eliminado!",
              "El beneficiario ha sido eliminado.",
              "success",
            );
            this.cargarBeneficiarios(); // Asegúrate de llamar al método correcto
          },
          error: (error) => {
            console.error("❌ Error al eliminar beneficiario:", error);
            Swal.fire("Error", "No se pudo eliminar el beneficiario.", "error");
          },
        });
      }
    });
  }

  openModalBeneficiario(content: any, beneficiario?: any) {
    if (beneficiario) {
      this.editMode = true;
      this.beneficiarioSeleccionado = beneficiario;
      this.formBeneficiario.patchValue(beneficiario); // Carga datos en el formulario
    } else {
      this.editMode = false;
      this.formBeneficiario.reset(); // Limpia el formulario para un nuevo beneficiario
    }

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

  guardarBeneficiario() {
    if (this.formBeneficiario.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    const datosBeneficiario = this.formBeneficiario.value;

    if (this.editMode) {
      // **Actualizar beneficiario**
      this.beneficiariosservice
        .updateBeneficiario(
          this.beneficiarioSeleccionado.documento,
          datosBeneficiario,
        )
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Beneficiario actualizado correctamente.",
            });
            this.cerrarModalYRecargar();
          },
          error: (err) => {
            this.mostrarError(err, "Error al actualizar");
          },
        });
    } else {
      // **Crear nuevo beneficiario**
      this.beneficiariosservice
        .createBeneficiario(datosBeneficiario)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Guardado exitoso",
              text: "Beneficiario creado correctamente.",
            });
            this.formBeneficiario.reset();
            this.cerrarModalYRecargar();
          },
          error: (err) => {
            this.mostrarError(err, "Error al guardar");
          },
        });
    }
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.cargarBeneficiarios(); // Recarga la lista
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  cargarAcademica(): void {
    this.academiaservice.getAcademiasByCedula(this.formData.cedula).subscribe({
      next: (data) => {
        this.academias = Array.isArray(data) ? data : [];
        //console.log('✅ Datos académicos cargados:', this.academias);
      },
      error: (err) => {
        console.error("❌ Error al cargar datos académicos:", err);
        this.academias = []; // Previene que quede en estado indefinido
      },
    });
  }

  inactivarAcademica(id: string | number): void {
    const documentoNum = Number(id);

    if (isNaN(documentoNum)) {
      Swal.fire(
        "Error",
        "ID inválido. No se puede eliminar el registro.",
        "error",
      );
      return;
    }

    Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a eliminar el registro académico con ID: ${documentoNum}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.academiaservice.deleteAcademia(documentoNum).subscribe({
          next: () => {
            Swal.fire(
              "¡Eliminado!",
              "El registro académico ha sido eliminado correctamente.",
              "success",
            );
            this.cargarAcademica();
          },
          error: (error) => {
            console.error("❌ Error al eliminar el registro académico:", error);
            Swal.fire(
              "Error",
              "Ocurrió un problema al eliminar el registro.",
              "error",
            );
          },
        });
      }
    });
  }

  openModalAcademica(content: any, academia?: any) {
    if (academia) {
      this.editMode = true;
      this.academiaselecionada = academia;
      this.formAcademia.patchValue(academia); // Carga datos en el formulario
    } else {
      this.editMode = false;
      this.formAcademia.reset(); // Limpia el formulario para un nuevo beneficiario
    }

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

  guardarAcademica() {
    if (this.formAcademia.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    const datosAcademia = {
      ...this.formAcademia.value,
      cedula: this.formData.cedula, // Asegúrate de que `this.cedula` contiene el valor correcto
    };

    if (this.editMode) {
      // **Actualizar beneficiario**
      this.academiaservice
        .updateAcademia(this.academiaselecionada.id, datosAcademia)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Título Académico actualizado correctamente.",
            });
            this.cerrarModalYRecargar2();
          },
          error: (err) => {
            this.mostrarError2(err, "Error al actualizar");
          },
        });
    } else {
      // **Crear nuevo beneficiario**
      this.academiaservice.createAcademia(datosAcademia).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Guardado exitoso",
            text: "Título Académico creado correctamente.",
          });
          this.formAcademia.reset();
          this.cerrarModalYRecargar2();
        },
        error: (err) => {
          this.mostrarError2(err, "Error al guardar");
        },
      });
    }
  }

  private cerrarModalYRecargar2() {
    this.modalService.dismissAll(); // Cierra el modal
    this.cargarAcademica(); // Recarga la lista
  }

  private mostrarError2(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  cargarLaboral() {
    this.laboralservice.getLaborales().subscribe({
      next: (data) => {
        this.laborales = data;
      },
      error: (err) => {
        console.error("❌ Error al cargar experiencia laboral:", err);
      },
    });
  }

  inactivarLaboral(id: string | number) {
    const documentoNum = Number(id); // Asegura que sea un número

    Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a eliminar el registro Experiencia laboral con ID: ${documentoNum}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.laboralservice.deleteLaboral(documentoNum).subscribe({
          next: () => {
            Swal.fire(
              "¡Eliminado!",
              "El registro experiencia laboral ha sido eliminado.",
              "success",
            );
            this.listarLaboral(); // Asegúrate de llamar al método correcto para recargar los datos
          },
          error: (error) => {
            console.error(
              "❌ Error al eliminar el registro experiencia laboral:",
              error,
            );
            Swal.fire(
              "Error",
              "No se pudo eliminar el registro experiencia laboral.",
              "error",
            );
          },
        });
      }
    });
  }

  openModalLaboral(content: any, laborales?: any) {
    // console.log(laborales);

    if (laborales) {
      console.log("modio editar");
      this.editMode = true;
      this.laboralselecionada = laborales;
      this.formLaboral.patchValue(laborales); // Carga datos en el formulario
    } else {
      this.editMode = false;
      console.log("modio add");
      this.formLaboral.reset(); // Limpia el formulario para un nuevo beneficiario
    }

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
  }

  guardarLaboral() {
    const datosLaboral = {
      ...this.formLaboral.value, // Copia todos los valores del formulario
      cedula: this.formData.cedula, // Agrega el valor de la cédula
    };

    if (this.editMode) {
      // **Actualizar registro existente**
      this.laboralservice
        .updateLaboral(this.laboralselecionada.id, datosLaboral)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "Experiencia laboral actualizada correctamente.",
            });
            this.modalService.dismissAll();
            this.formLaboral.reset();
            this.listarLaboral();
          },
          error: (error) => {
            console.error("❌ Error al actualizar experiencia laboral:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "No se pudo actualizar la experiencia laboral.",
            });
          },
        });
    } else {
      // **Crear nuevo registro**
      this.laboralservice.createLaboral(datosLaboral).subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Registro exitoso",
            text: "Experiencia laboral guardada correctamente.",
          });
          this.modalService.dismissAll();
          this.formLaboral.reset();
          this.listarLaboral();
        },
        error: (error) => {
          console.error("❌ Error al guardar experiencia laboral:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo guardar la experiencia laboral.",
          });
        },
      });
    }
  }

  private cerrarModalYRecargar3() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarLaboral(); // Recarga la lista
  }

  private mostrarError3(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formEmpresa.value };

    // Validación de correo
    const email = datos.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      this.mostrarAlerta(
        "Email inválido",
        "Correo no válido. Ej: usuario@dominio.com",
        "info",
      );
      return;
    }

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
      {
        campo: "nit",
        mensaje: "Por favor, ingresa un número de documento",
        ref: this.inputNit,
      },
      {
        campo: "digito",
        mensaje: "Por favor, ingresa un dígito de verificación",
        ref: this.inputCodigo,
      },
      {
        campo: "nombre",
        mensaje: "Por favor, ingresa un nombre",
        ref: this.inputNombre,
      },
      {
        campo: "direccion",
        mensaje: "Por favor, ingresa una dirección",
        ref: this.inputDireccion,
      },
      {
        campo: "ciudad",
        mensaje: "Por favor, ingresa una ciudad",
        ref: this.inputCiudad,
      },
      {
        campo: "celular",
        mensaje: "Por favor, ingresa un número de celular",
        ref: this.inputCelular,
      },
      {
        campo: "email",
        mensaje: "Por favor, ingresa un correo electrónico",
        ref: this.inputEmail,
      },
    ];

    for (const { campo, mensaje, ref } of camposObligatorios) {
      const valor = this.formEmpresa.get(campo)?.value;

      // Para el campo digito, aceptar 0 como válido
      if (campo === "digito") {
        if (valor === null || valor === undefined || valor === "") {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      } else {
        if (!valor) {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      }
    }

    // Convertir checkboxes a 1/0
    const checkboxKeys = [
      "eps",
      "arl",
      "afp",
      "ces",
      "ccf",
      "bancos",
      "transporte",
      "colegio",
      "cda",
      "taller",
      "eds",
      "contratista",
      "proveedor",
      "aseguradora",
      "almacen",
      "entidad",
      "serviteca",
    ];
    checkboxKeys.forEach((k) => {
      if (k === "entidad") {
        datos[k] = 1;
      } else {
        datos[k] = datos[k] ? 1 : 0;
      }
    });

    datos.estado = 1; // Activar empresa al guardar
    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        // 🔁 Recargar lista de talleres para incluir el nuevo
        this.empresasService.getEntidad().subscribe({
          next: (data) => {
            this.empresaData = data;
          },
        });

        // Opcional: seleccionar automáticamente el taller recién creado
        this.formEmpresa.patchValue({ taller: empresaCreada.nombre });

        Swal.fire("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar la empresa", "error");
      },
    });
  }

  private cerrarModalYRecargar4() {
    this.modalService.dismissAll(); // Cierra el modal
    this.cargarExamenes(); // Recarga la lista
  }

  private mostrarError4(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  // Cargar todos los datos de las APIs en paralelo
  private cargarDatos(): void {
    forkJoin({
      empresas: this.empresasService.getEPS(),
      empresaARL: this.empresasService.getARL(),
      empresaAFP: this.empresasService.getAFP(),
      empresaCES: this.empresasService.getCES(),
      empresaCCF: this.empresasService.getCCF(),
    }).subscribe({
      next: ({ empresas, empresaARL, empresaAFP, empresaCES, empresaCCF }) => {
        this.empresas = empresas;
        this.empresaARL = empresaARL;
        this.empresaAFP = empresaAFP;
        this.empresaCES = empresaCES;
        this.empresaCCF = empresaCCF;
      },
      error: (error) => this.handleError(error),
    });
  }

  // Manejo de errores genérico
  private handleError(error: any): void {
    console.error("Error al obtener datos:", error);
  }
  cargarDatosPropietario(id: string) {
    this.loading = true;
    this.propietarioService.getPropietariobyIdPersona(id).subscribe(
      (data) => {
        this.propietarioSeleccionado = data;

        // Optimización: Convertir todas las fechas en un solo bucle
        const camposFecha = [
          "fechanace",
          "firmacontrato",
          "vencecontrato",
          "fechaponal",
          "fechaprocu",
          "fechaarl",
          "fechaafp",
          "fechaccf",
          "fechaces",
          "fechacobafp",
          "fechacobarl",
          "fechacobces",
          "fechacobeccf",
          "fechacobeps",
          "fechaeps",
        ];

        camposFecha.forEach((campo) => {
          if (data[campo]) {
            const targetField =
              campo === "fechanace" ? "fechanacimiento" : campo;
            data[targetField] = new Date(data[campo])
              .toISOString()
              .split("T")[0];
          }
        });

        this.formData = data;

        // En cargarDatosPropietario, después de this.formData = data:
       this.propietarioService.getProfesiogramaByCedula(data.cedula).subscribe({
        next: (resp: any) => {
          this.examenesBase = Array.isArray(resp.examenes) ? resp.examenes : [];
          this.tiposExamenProfesiograma = Array.isArray(resp.tiposExamen) ? resp.tiposExamen : [];

          // ✅ Ya no se sobreescribe formData después de esto
          this.formData.ExamenesData = this.examenesBase.map((ex: any) => ({
            id: ex.id,
            
            
            
            nombre: ex.nombre,
            descripcion: ex.descripcion,
            realizo: null,
            tipo_examen: null,
            id_realizado: null,
          }));
        },
        error: (err) => {
          console.error("Error cargando profesiograma:", err);
          this.examenesBase = [];
          this.tiposExamenProfesiograma = [];
          this.formData.ExamenesData = [];
        },
      });
        this.validarCargo();

        // Verificar si existe firma previa (async/await)
        //  console.log('⏳ Iniciando búsqueda de firma previa...');
        this.verificarFirmaExistente(data.cedula);

        // Una relación sin registros no debe impedir cargar las demás.
        forkJoin({
           municipios: this.dataService.getDatos(),
            bancos: this.bancosService.getBancos(),
            datacondicion: this.condicionSerivice.getAllCondicion(),
            datacargos: this.cargosService.getCargosActivos(),
            dataCiviles: this.civilService.getCiviles(),
            dataRaza: this.razaService.getRazas(),
            NucleoFamiliar: this.nucleoFamiliarService.getNucleosFamiliares(),
            areaData: this.areaService.getAreas(),
            empresaData: this.empresaService.getEntidad().pipe(catchError(() => of([]))),
            tiposExamenData: this.tiposExamenService.getTiposExamen().pipe(catchError(() => of([]))),
            codigoInfraccionData: this.codigoinfraccionservice.getAllCodigoInfraccion(),
            estadosMultas: this.estadoMultaService.getAllEstados(),
            tiposDocumentoData: this.tipodocumentoservice.getTiposDocumento(),
            programacionActivosData: this.programacionService.getAllCapacitacionProgramacionActivos(),
            tipocontratoData: this.tipocontratoService.getTiposContrato(),
            seguridadsocialData: this.seguridadsocialservice.getSeguridadSocial(),
            nivelestudiodata: this.nivelEstudioService.getAllNivelEstudio(),
            infracciones: this.infraccionesService  
            .getInfraccionesByDocumento(data.cedula)
            .pipe(catchError(() => of([]))),
          laborales: this.laboralservice
            .getLaboralByCedula(data.cedula)
            .pipe(catchError(() => of([]))),
          academias: this.academiaservice
            .getAcademiasByCedula(data.cedula)
            .pipe(catchError(() => of([]))),
          examenes: this.examenesMedicosService
            .getExamenesMedicosByCedula(data.cedula)
            .pipe(catchError(() => of([]))),
          asistentes: this.asistenciaService
            .getCapacitacionAsistenciaByCedula(data.cedula)
            .pipe(catchError(() => of([]))),
            
        }).subscribe({
          next: (resultados) => {
            console.log('Resultados obtenidos:', resultados.programacionActivosData);
            this.infracciones = Array.isArray(resultados.infracciones)
              ? resultados.infracciones.map((infraccion) => ({
                  ...infraccion,
                  showMenu: false,
                }))
              : [];
            this.laborales = Array.isArray(resultados.laborales)
              ? resultados.laborales.map((laboral) => ({
                  ...laboral,
                  showMenu: false,
                }))
              : [];
            this.academias = Array.isArray(resultados.academias)
              ? resultados.academias
              : [];
            this.asistentes = Array.isArray(resultados.asistentes)
              ? resultados.asistentes
              : [];
            this.examenes = Array.isArray(resultados.examenes)
              ? resultados.examenes
              : [];
            this.bancos = Array.isArray(resultados.bancos)
              ? resultados.bancos
              : [];
            this.municipios = Array.isArray(resultados.municipios)
              ? resultados.municipios
              : [];
            this.datacargos = Array.isArray(resultados.datacargos)
                ? resultados.datacargos
                : [];
            this.datacondicion = Array.isArray(resultados.datacondicion)
                ? resultados.datacondicion
                : [];
            this.tipocontratoData = Array.isArray(resultados.tipocontratoData)
                  ? resultados.tipocontratoData
                  : [];
            this.dataCiviles = Array.isArray(resultados.dataCiviles)
                ? resultados.dataCiviles
                : [];
            this.empresaData = Array.isArray(resultados.empresaData)
              ? resultados.empresaData
              : Array.isArray(resultados.empresaData?.data)
                ? resultados.empresaData.data
                : Array.isArray(resultados.empresaData?.empresas)
                  ? resultados.empresaData.empresas
                  : [];

            this.dataRaza = Array.isArray(resultados.dataRaza)
                ? resultados.dataRaza
                : [];
            this.codigoinfracciondata = Array.isArray(resultados.codigoInfraccionData)
              ? resultados.codigoInfraccionData
              : [];
            this.estadosMultas = Array.isArray(resultados.estadosMultas)
              ? resultados.estadosMultas
              : [];
            this.programacionActivosData = Array.isArray(resultados.programacionActivosData)
              ? resultados.programacionActivosData.map((programacion: any) => ({
                  ...programacion,
                  id: programacion.capacitacion_id,
                  nombreCapacitacion: programacion.capacitacion?.nombre
                    || programacion.nombreCapacitacion
                    || programacion.nombre
                    || 'Capacitación sin nombre',
                }))
              : [];
            this.nivelestudiodata = Array.isArray(resultados.nivelestudiodata)
              ? resultados.nivelestudiodata
              : [];
           this.areaData = Array.isArray(resultados.areaData)
                ? resultados.areaData
                : []; 
            this.NucleoFamiliar = Array.isArray(resultados.NucleoFamiliar)
                ? resultados.NucleoFamiliar
                : [];
            this.seguridadsocialData = Array.isArray(resultados.seguridadsocialData)
                ? resultados.seguridadsocialData
                : [];

            this.loading = false;
          },
          error: (error) => {
            console.error("Error cargando datos relacionados:", error);
            this.infracciones = [];
            this.laborales = [];
            this.academias = [];
            this.examenes = [];
            this.asistentes = [];
            this.loading = false;
          },
        });
      },
      (error) => {
        console.error("Error cargando datos del propietario:", error);
        this.loading = false;
      },
    );
  }

  /**
   * Detecta la extensión real de la firma en Google Cloud Storage
   * Busca FIRMA_dibujo y FIRMA_foto con extensiones png, jpg, jpeg, pdf
   */
  /**
   * Detecta la extensión real de la firma en Google Cloud Storage
   * Busca FIRMA_cedula con extensiones png, jpg, jpeg, pdf
   */
  private async detectarExtensioFirma(
    basePath: string,
  ): Promise<{ ext: string; tipo?: "dibujo" | "foto" } | null> {
    const extensiones = ["png", "jpg", "jpeg", "pdf"];

    // Buscar patrón: FIRMA_cedula.ext
    for (const ext of extensiones) {
      const rutaCompleta = `${basePath}_${this.formData.cedula}.${ext}`;
      try {
        //   console.log(`   🔍 Probando firma: ${rutaCompleta}`);
        const res = await this.gpcGoogleService
          .getSignedUrl(rutaCompleta)
          .toPromise();
        if (res?.url) {
          //   console.log(`   ✅ Firma encontrada: ${ext}`);
          return { ext };
        }
      } catch (err) {
        console.log(`   ❌ No existe con extensión: ${ext}`);
      }
    }

    console.log(`   ❌ No se encontró firma para: ${basePath}`);
    return null;
  }

  /**
   * Verificar si existe firma previa en Google Cloud Storage
   */
  private async verificarFirmaExistente(cedula: string): Promise<void> {
    //console.log(`🔍 Verificando firma para cédula: ${cedula}`);

    // Obtener NIT de administraciones
    const nit =
      this.administraciones && this.administraciones.length > 0
        ? this.administraciones[0].nit
        : "";

    //console.log(`📍 NIT obtenido: ${nit}`);
    //console.log(`📍 Cedula: ${cedula}`);

    if (!nit || !cedula) {
      console.error("❌ NIT o cedula inválidos");
      this.firmaExistente = null;
      return;
    }

    // Construir ruta base sin extensión ni tipo
    const rutaBase = `${nit}/personas/${cedula}/FIRMA`;
    // console.log(`📍 Ruta base: ${rutaBase}`);

    // Detectar extensión real
    const resultado = await this.detectarExtensioFirma(rutaBase);

    if (resultado) {
      // Construir ruta completa: FIRMA_cedula.ext
      const rutaCompleta = `${rutaBase}_${cedula}.${resultado.ext}`;

      // console.log(`✅ Firma detectada: ${rutaCompleta}`);

      // Obtener signed URL
      try {
        // console.log(`⏳ Obteniendo signed URL...`);
        const apiResponse = await this.gpcGoogleService
          .getSignedUrl(rutaCompleta)
          .toPromise();

        // Asegurar que signedUrl es string
        let signedUrl: string = "";
        if (typeof apiResponse === "string") {
          signedUrl = apiResponse;
        } else if (apiResponse?.url && typeof apiResponse.url === "string") {
          signedUrl = apiResponse.url;
        }

        //console.log(`✅ Signed URL obtenida:`, signedUrl);

        if (signedUrl) {
          this.firmaExistente = {
            ruta: signedUrl,
          };
          //  console.log('✅ firmaExistente asignada:', JSON.stringify(this.firmaExistente, null, 2));
        } else {
          console.error("❌ No se pudo extraer URL válida");
          this.firmaExistente = null;
        }
      } catch (err) {
        console.error("⚠️ Error obteniendo signed URL:", err);
        this.firmaExistente = null;
      }
    } else {
      console.log("❌ No se encontró archivo FIRMA");
      this.firmaExistente = null;
    }
  }

  obtenerTiposVivienda() {
    this.tipoViviendaService.getAll().subscribe((data) => {
      //     console.log(data);
      this.TipoDeVivienda = data;
    });
  }

  onFirmaCargada(urlFirma: string): void {
    // Firma cargada - sin loguear URLs sensibles
  }

  limitarLongitud(event: Event, max: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > max) {
      input.value = input.value.slice(0, max);
      // Actualiza el FormControl asociado
      const controlName = input.getAttribute("formControlName");
      if (controlName) {
        this.formEmpresa.get(controlName)?.setValue(input.value);
      }
    }
  }

cargarExamenes() {
  this.examenesMedicosService
    .getExamenesMedicosByCedula(this.formData.cedula)
    .subscribe({
      next: (data) => {
        this.examenes = data;
        this.count = data.length;
      },
      error: (err) => console.error("❌ Error al cargar exámenes médicos:", err),
    });
}

inactivarExamenes(id: string | number) {
  const documentoNum = Number(id);
  Swal.fire({
    title: "¿Estás seguro?",
    text: `Vas a inactivar el examen médico con ID: ${documentoNum}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      forkJoin([
        this.examenesMedicosService.inactivarExamenesMedicos(documentoNum),
        this.examenesRelizadosService.inactivarExamenesRealizadosPorExamenMedico(documentoNum),
      ]).subscribe({
        next: () => {
          Swal.fire("¡Eliminado!", "El examen médico y sus realizados fueron inactivados.", "success");
          this.cargarExamenes();
        },
        error: () => Swal.fire("Error", "No se pudo inactivar el examen médico.", "error"),
      });
    }
  });
}

openModalExamenes(content: any, examenes?: any) {
  if (!examenes) {
    // ── MODO CREAR ──
    this.editMode = false;
    this.examenesselecionadas = null;
    this.tipoExamenSeleccionado = null;
    this.examenesDataFiltrados = []; // 👈 limpia la vista
    this.formExamenes.reset();

    this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });
    return;
  }

  // ── MODO EDITAR ──
  this.editMode = true;
  this.examenesselecionadas = examenes;
  this.tipoExamenSeleccionado = examenes.tipo_examen;

  this.formExamenes.patchValue({
    fecha_realizo: examenes.fecha_realizo,
    fecha_vencimiento: examenes.fecha_vencimiento,
    entidad: examenes.empresa?.nit ?? examenes.entidad,
  });

  this.examenesRelizadosService
    .getExamenRealizadoByExamenMedico(examenes.id)
    .subscribe({
      next: (realizados: any[]) => {
        // Obtener exámenes del tipo seleccionado
        const tipoActual = this.tiposExamenProfesiograma.find(
          (t: any) => t.tipo_examen_id === this.tipoExamenSeleccionado
        );
        const examenesDelTipo = tipoActual?.examenes || this.examenesBase || [];

        if (!realizados || realizados.length === 0) {
          this.examenesDataFiltrados = examenesDelTipo.map((ex: any) => ({
             id: ex.id,
  nombre: ex.nombre,
  descripcion: ex.descripcion,
  realizo: null,
  id_realizado: null,
  // 👇 campos para documento
  file: null,
  estado: null,
  progreso: 0,
  mensaje: '',
  soporteExistente: null,
          }));
        } else {
          const combinados = examenesDelTipo.map((base: any) => {
            const realizado = realizados.find(
              (r: any) => Number(r.examen) === Number(base.id)
            );
            return {
              id: base.id,
  nombre: base.nombre,
  descripcion: base.descripcion,
  realizo: realizado?.realizo ?? null,
  id_realizado: realizado?.id ?? null,
  file: null,
  estado: null,
  progreso: 0,
  mensaje: '',
  soporteExistente: null,
            };
          });

          // Agregar realizados que ya no están en el profesiograma
          realizados.forEach((r: any) => {
            const existe = combinados.some((x: any) => Number(x.id) === Number(r.examen));
            if (!existe) {
              combinados.push({
                id: r.examen,
                nombre: r.examenInfo?.nombre || "EXAMEN",
                descripcion: r.examenInfo?.descripcion || "",
                realizo: r.realizo ?? null,
                id_realizado: r.id ?? null,
              });
            }
          });

          this.examenesDataFiltrados = combinados;
        }

        this.modalService.open(content, {
          size: "xl",
          backdrop: "static",
          windowClass: "custom-modal-full-width",
        });
      },
      error: (err) => {
        console.error("❌ Error al cargar exámenes realizados:", err);
        this.examenesDataFiltrados = [];
        this.modalService.open(content, {
          size: "xl",
          backdrop: "static",
          windowClass: "custom-modal-full-width",
        });
      },
    });
}

onTipoExamenChange() {
  this.calcularFechaVencimiento(); // tu método existente

  if (!this.tipoExamenSeleccionado) {
    this.examenesDataFiltrados = [];
    return;
  }

  const tipoActual = this.tiposExamenProfesiograma.find(
    (t: any) => t.tipo_examen_id === this.tipoExamenSeleccionado
  );

  // examenes dentro del tipo seleccionado
  const examenesDelTipo = tipoActual?.examenes || [];

  this.examenesDataFiltrados = examenesDelTipo.map((ex: any) => ({
    id: ex.id,
    nombre: ex.nombre,
    descripcion: ex.descripcion,
    realizo: null,
    id_realizado: null,
  }));
}

guardarExamenes() {
    if (!this.tipoExamenSeleccionado) {
    this.mostrarAlerta("Campo requerido", "Selecciona un tipo de examen.", "info");
    return;
  }

  if (!this.formExamenes.get('fecha_realizo')?.value) {
    this.mostrarAlerta("Campo requerido", "Ingresa la fecha de realización.", "info");
    return;
  }

  if (!this.formExamenes.get('fecha_vencimiento')?.value) {
    this.mostrarAlerta("Campo requerido", "Ingresa la fecha de vencimiento.", "info");
    return;
  }

  if (!this.formExamenes.get('entidad')?.value) {
    this.mostrarAlerta("Campo requerido", "Selecciona una entidad.", "info");
    return;
  }

  if (this.examenesDataFiltrados.length === 0) {
    this.mostrarAlerta("Sin exámenes", "Este tipo de examen no tiene exámenes asignados.", "info");
    return;
  }


const examenSinRealizo = this.examenesDataFiltrados.find(
    (ex: any) => ex.realizo === null || ex.realizo === undefined
  );
  if (examenSinRealizo) {
    this.mostrarAlerta("Campo requerido", `Indica si el examen "${examenSinRealizo.nombre}" fue realizado.`, "info");
    return;
  }

  const datosExamenes = {
    ...this.formExamenes.value,
    cedula: this.formData.cedula,
    tipo_examen: this.tipoExamenSeleccionado,
  };

  if (this.editMode) {
    // ── EDITAR ──
    const examenesRealizados = this.examenesDataFiltrados.map((examen: any) => ({
      id_realizado: examen.id_realizado,
      cedula: this.formData.cedula,
      examen: examen.id,
      realizo: examen.realizo ?? null,
      descripcion: examen.descripcion,
      id_examen_medico: this.examenesselecionadas.id,
    }));

    const cambiosRealizados = examenesRealizados.filter((item: any) => {
      if (!item.id_realizado) {
        return item.realizo !== null || item.descripcion !== "";
      }
      const original = this.examenesselecionadas.realizados?.find(
        (r: any) => r.id == item.id_realizado
      );
      if (!original) return true;
      return (
        Number(original.realizo) !== Number(item.realizo) ||
        String(original.descripcion || "") !== String(item.descripcion || "")
      );
    });

    const requests: any[] = [];
    cambiosRealizados.forEach((item: any) => {
      if (item.id_realizado != null) {
        requests.push(this.examenesRelizadosService.updateExamenRealizado(item.id_realizado, item));
      } else {
        requests.push(this.examenesRelizadosService.createExamenRealizado(item));
      }
    });

    const examenPrincipalCambio =
      datosExamenes.fecha_realizo !== this.examenesselecionadas.fecha_realizo ||
      datosExamenes.fecha_vencimiento !== this.examenesselecionadas.fecha_vencimiento ||
      datosExamenes.entidad !== this.examenesselecionadas.entidad;

    if (examenPrincipalCambio) {
      requests.push(
        this.examenesMedicosService.updateExamenMedico(this.examenesselecionadas.id, datosExamenes)
      );
    }

    if (requests.length === 0) {
      Swal.fire({ icon: "info", title: "Sin cambios", text: "No se detectaron cambios." });
      return;
    }

    forkJoin(requests).subscribe({
      next: () => {
        Swal.fire({ icon: "success", title: "Guardado exitoso", text: "Los cambios fueron guardados correctamente." });
        this.cargarExamenes();
        this.formExamenes.reset();
        this.cerrarModalYRecargar4();
      },
      error: (err) => this.mostrarError4(err, "Error al guardar"),
    });

  } else {
    // ── CREAR ──
    const examenesRealizados = this.examenesDataFiltrados
      .filter((ex: any) => ex.realizo !== null && ex.realizo !== undefined)
      .map((examen: any) => ({
        examen: examen.id,
        realizo: examen.realizo,
        descripcion: examen.descripcion ?? null,
      }));

    const payload = {
      ...datosExamenes,
      examenes_realizados: examenesRealizados,
    };

    this.examenesMedicosService.createExamenMedico(payload).subscribe({
      next: () => {
        Swal.fire({ icon: "success", title: "Guardado exitoso", text: "Examen médico creado correctamente." });
        this.cargarExamenes();
        this.formExamenes.reset();
        this.examenesDataFiltrados = [];
        this.cerrarModalYRecargar4();
      },
      error: (err) => this.mostrarError4(err, "Error al guardar examen médico"),
    });
  }
}

  calcularFechaVencimiento(): void {
    const fechaRealizo = this.formExamenes.get("fecha_realizo")?.value;

    if (!fechaRealizo || !this.tipoExamenSeleccionado) {
      return;
    }

    // Buscar el tipo seleccionado
    const tipo = this.tiposExamenProfesiograma.find(
      (t: any) => t.tipo_examen_id == this.tipoExamenSeleccionado,
    );

    if (!tipo) {
      return;
    }

    const periodicidad = Number(tipo.periodicidad_meses || 0);

    // Crear fecha
    const fecha = new Date(fechaRealizo);

    // Sumar meses
    fecha.setMonth(fecha.getMonth() + periodicidad);

    // Formato YYYY-MM-DD
    const fechaVencimiento = fecha.toISOString().split("T")[0];

    // Setear control
    this.formExamenes.patchValue({
      fecha_vencimiento: fechaVencimiento,
    });
  }

  // ── DOCUMENTOS POR EXAMEN ──

onFileChangeExamen(event: any, examen: any) {
  const file: File = event.target.files[0];
  if (!file) return;

  const extension = file.name.split('.').pop()?.toLowerCase();
  const permitidos = ['jpg', 'jpeg', 'png', 'pdf'];

  if (!permitidos.includes(extension || '')) {
    examen.estado = 'error';
    examen.mensaje = 'Formato no permitido. Solo JPG, PNG o PDF.';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e: any) => {
    examen.file = { file, preview: e.target.result };
    examen.estado = null;
    examen.mensaje = '';
    examen.progreso = 0;
  };
  reader.readAsDataURL(file);
}

onDragOverExamen(event: DragEvent) {
  event.preventDefault();
  (event.currentTarget as HTMLElement).classList.add('drag-over');
}

onDragLeaveExamen(event: DragEvent) {
  event.preventDefault();
  (event.currentTarget as HTMLElement).classList.remove('drag-over');
}

onDropExamen(event: DragEvent, examen: any) {
  event.preventDefault();
  (event.currentTarget as HTMLElement).classList.remove('drag-over');

  const file = event.dataTransfer?.files[0];
  if (!file) return;

  const extension = file.name.split('.').pop()?.toLowerCase();
  const permitidos = ['jpg', 'jpeg', 'png', 'pdf'];

  if (!permitidos.includes(extension || '')) {
    examen.estado = 'error';
    examen.mensaje = 'Formato no permitido. Solo JPG, PNG o PDF.';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e: any) => {
    examen.file = { file, preview: e.target.result };
    examen.estado = null;
    examen.mensaje = '';
    examen.progreso = 0;
  };
  reader.readAsDataURL(file);
  event.dataTransfer.clearData();
}

removeFileExamen(examen: any) {
  examen.file = null;
  examen.estado = null;
  examen.progreso = 0;
  examen.mensaje = '';
}

isImageExamen(file: File): boolean {
  return ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
}

subirArchivoExamen(examen: any) {
  if (!examen.file) return;

  examen.estado = 'subiendo';
  examen.progreso = 0;

  // Carpeta: nit/examenes_medicos/cedula/EXAMEN_id_examen
  const nit = this.administraciones?.[0]?.nit ?? 'default';
  const cedula = this.formData.cedula;
  const nombreCarpeta = `${nit}/examenes_medicos/${cedula}`;
  const nombreArchivo = `EXAMEN_${examen.id}_${cedula}`;
  const prefijo = `EXAMEN_${examen.id}`;

  this.digitalesService
    .subirArchivo(examen.file.file, examen.id, nombreCarpeta, nombreArchivo, prefijo)
    .subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          examen.progreso = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          examen.estado = 'exito';
          examen.mensaje = 'Documento subido con éxito';
          examen.soporteExistente = {
            url: examen.file.preview,
            isImage: this.isImageExamen(examen.file.file),
            name: examen.file.file.name,
          };
        }
      },
      error: () => {
        examen.estado = 'error';
        examen.mensaje = 'Error al subir el documento';
      },
    });
}
 // ── Asistentes ───────────────────────────────────────────────
  asistioLabel(asistencia: AsistenciaRow): boolean {
   // console.log(asistencia);
    return Number(asistencia?.asistio ?? 0) === 1;
  }
    aprobadoLabel(asistencia: AsistenciaRow): boolean {
    return Number(asistencia?.aprobado ?? 0) === 1;
  }

    abrirModalEditarAsistente(asistencia: AsistenciaRow, content: TemplateRef<any>): void {
    if (!asistencia?.id) return;

    this.editAsistenciaModalRef = this.modalService.open(content, {
      centered: true, size: "xl", backdrop: "static",
    });

    this.editAsistenciaForm = {
      capacitacion_id: undefined, cedula: undefined, nombre: "",
      asistio: 1, aprobado: 0, calificacion: null, observaciones: "", estado: 1,
    };

    this.loading = true;

    setTimeout(() => {
      this.asistenciaService.getCapacitacionAsistenciaById(asistencia.id).subscribe({
        next: (data: any) => {
          this.loading        = false;
          this.editAsistenciaId = Number(data.id);
          this.editAsistenciaForm = {
            capacitacion_id: data.capacitacion_id ?? undefined,
            cedula:          data.cedula          ?? undefined,
            nombre:          data.nombre          ?? "",
            asistio:         Number(data.asistio  ?? 1),
            aprobado:        Number(data.aprobado ?? 0),
            calificacion:    data.calificacion != null ? Number(data.calificacion) : null,
            observaciones:   data.observaciones   ?? "",
            estado:          Number(data.estado   ?? 1),
          };
          this.editError = "";
        },
        error: (error) => {
          this.loading = false;
          this.editAsistenciaModalRef?.close();
          Swal.fire({ icon: "error", title: "Error", text: error?.error?.message || "No se pudo cargar la asistencia" });
        },
      });
    });
  }

  guardarEdicionAsistencia(): void {
    this.editError = "";

    if (!this.editAsistenciaId) {
      this.mostrarAlerta(
        "Error",
        "No se encontró la asistencia a editar",
        "error",
      );

      return;
    }

    if (!this.editAsistenciaForm.capacitacion_id) {
      this.mostrarAlerta(
        "Campo requerido",
        "Seleccione la capacitación",
        "info",
      );

      return;
    }

    if (!this.editAsistenciaForm.cedula) {
      this.mostrarAlerta("Campo requerido", "Ingrese la cédula", "info");
      return;
    }

    if (!this.editAsistenciaForm.nombre?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese el nombre", "info");
      return;
    }

    const payload: CapacitacionAsistenciaView = {
      capacitacion_id: Number(this.editAsistenciaForm.capacitacion_id),
      cedula: Number(this.editAsistenciaForm.cedula),
      nombre: this.editAsistenciaForm.nombre.trim().toUpperCase(),
      asistio: Number(this.editAsistenciaForm.asistio ?? 1),
      aprobado: Number(this.editAsistenciaForm.aprobado ?? 0),
      calificacion: this.editAsistenciaForm.calificacion ?? null,
      observaciones: this.editAsistenciaForm.observaciones?.trim() ?? "",
      estado: Number(this.editAsistenciaForm.estado ?? 1),
    };

    this.loading = true;

    this.asistenciaService
      .updateCapacitacionAsistencia(this.editAsistenciaId, payload)
      .subscribe({
        next: () => {
          this.loading = false;

          // GUARDAR PÁGINA ACTUAL
          const paginaActual = this.page;

          // RECARGAR LISTADO GENERAL
          this.cargarAsistentesProgramacion();

          // RESTAURAR PÁGINA
          this.page = paginaActual;

          this.editAsistenciaModalRef?.close();

          Swal.fire({
            icon: "success",
            title: "Asistencia actualizada",
            text: "El registro se actualizó correctamente.",
          });
        },

        error: (error) => {
          this.loading = false;

          Swal.fire({
            icon: "error",
            title: "No se pudo guardar la asistencia",
            text:
              error?.error?.message ||
              "Revisa la información e inténtalo de nuevo.",
          });
        },
      });
  }
  cargarAsistentesProgramacion(): void {
    this.asistenciaService
      .getCapacitacionAsistenciaByCedula(this.formData.cedula)
      .subscribe({
        next: (data) => {
          this.asistentes = data;
        },

        error: () => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudieron actualizar los asistentes",
          });
        },
      });
  }
  cargarInvitadosProgramacion(id: number | string): void {
    this.loadingInvitados = true;
    this.capacitacionInvitadosService.getCapacitacionInvitadoById(id).subscribe({
      next: (data) => { this.loadingInvitados = false; this.invitadosProgramacion = data ?? []; },
      error: () => {
        this.loadingInvitados = false;
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los invitados." });
      },
    });
  }

  abrirModalNuevoAsistente(content: TemplateRef<any>): void {
    this.newAsistenciaForm = {
      capacitacion_id: this.selectedProgramacionId ?? undefined,

      cedula: this.formData.cedula ?? undefined,
      nombre: `
  ${this.formData.primernombre ?? ""}
  ${this.formData.segundonombre ?? ""}
  ${this.formData.papellidos ?? ""}
  ${this.formData.seapellidos ?? ""}
  `
        .replace(/\s+/g, " ")
        .trim(),
      asistio: 1,
      aprobado: 0,
      calificacion: null,
      observaciones: "",
      estado: 1,
    };

    this.createError = "";

    this.createModalRef = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
  }

   guardarNuevaAsistencia(): void {
    this.createError = "";

    if (!this.newAsistenciaForm.capacitacion_id) {
      this.mostrarAlerta(
        "Campo requerido",
        "Seleccione la capacitación",
        "info",
      );

      return;
    }

    if (!this.newAsistenciaForm.cedula) {
      this.mostrarAlerta("Campo requerido", "Ingrese la cédula", "info");
      return;
    }

    if (!this.newAsistenciaForm.nombre?.trim()) {
      this.mostrarAlerta("Campo requerido", "Ingrese el nombre", "info");
      return;
    }

    const payload: CapacitacionAsistenciaView = {
      capacitacion_id: Number(this.newAsistenciaForm.capacitacion_id),
      cedula: Number(this.newAsistenciaForm.cedula),
      nombre: this.newAsistenciaForm.nombre.trim().toUpperCase(),
      asistio: Number(this.newAsistenciaForm.asistio ?? 1),
      aprobado: Number(this.newAsistenciaForm.aprobado ?? 0),
      calificacion: this.newAsistenciaForm.calificacion ?? null,
      observaciones: this.newAsistenciaForm.observaciones?.trim() ?? "",
      estado: Number(this.newAsistenciaForm.estado ?? 1),
    };

    this.loading = true;

    this.asistenciaService.createCapacitacion(payload).subscribe({
      next: () => {
        this.loading = false;
        this.cargarAsistentesProgramacion();
        this.createModalRef?.close();

        Swal.fire({
          icon: "success",
          title: "Asistencia creada",
          text: "El registro de asistencia se creó correctamente.",
        });
      },

      error: (error) => {
        this.loading = false;

        Swal.fire({
          icon: "error",
          title: "No se pudo guardar la asistencia",

          text:
            error?.error?.message ||
            "Revisa la información e inténtalo de nuevo.",
        });
      },
    });
  }

onFileSelectedEdit(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    this.selectedFileEdit = null;
    return;
  }

  const file = input.files[0];

  // Validar que sea PDF
  if (file.type !== 'application/pdf') {
    this.mostrarAlerta(
      'Formato no válido',
      'Solo se permiten archivos PDF.',
      'warning'
    );

    input.value = '';
    this.selectedFileEdit = null;
    return;
  }

  // Validar tamaño (10 MB)
  const maxSize = 10 * 1024 * 1024;

  if (file.size > maxSize) {
    this.mostrarAlerta(
      'Archivo demasiado grande',
      'El archivo no puede superar los 10 MB.',
      'warning'
    );

    input.value = '';
    this.selectedFileEdit = null;
    return;
  }

  this.selectedFileEdit = file;
}

isImage(file: File): boolean {
  return file.type.startsWith('image/');
}  

}
